
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cJjDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $emEpv = parcelRequire("emEpv");

var $8Z2d1 = parcelRequire("8Z2d1");

var $5IU1g = parcelRequire("5IU1g");

var $3jiis = parcelRequire("3jiis");

var $4VfP7 = parcelRequire("4VfP7");

var $4mzy7 = parcelRequire("4mzy7");

var $lasFd = parcelRequire("lasFd");
var $9448ecaca302b8a4$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $3jiis.supportsWebCrypto)((0, $4mzy7.locateWindow)())) this.hash = new $8Z2d1.Sha256(secret);
        else if ((0, $4VfP7.isMsWindow)((0, $4mzy7.locateWindow)())) this.hash = new $emEpv.Sha256(secret);
        else this.hash = new $5IU1g.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update((0, $lasFd.convertToBuffer)(data));
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha256;
}();
module.exports.Sha256 = $9448ecaca302b8a4$var$Sha256;

});
parcelRegister("emEpv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $eTdA1 = parcelRequire("eTdA1");

var $5dlui = parcelRequire("5dlui");

var $bIXxp = parcelRequire("bIXxp");

var $4mzy7 = parcelRequire("4mzy7");
var $a7527767ff9f536e$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $eTdA1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($a7527767ff9f536e$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    Sha256.prototype.reset = function() {
        if (this.secret) {
            this.operation = $a7527767ff9f536e$var$getKeyPromise(this.secret).then(function(keyData) {
                return (0, $4mzy7.locateWindow)().msCrypto.subtle.sign($5dlui.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $4mzy7.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    };
    return Sha256;
}();
module.exports.Sha256 = $a7527767ff9f536e$var$Sha256;
function $a7527767ff9f536e$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $4mzy7.locateWindow)().msCrypto.subtle.importKey("raw", $a7527767ff9f536e$var$toArrayBufferView(secret), $5dlui.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $a7527767ff9f536e$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $bIXxp.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("eTdA1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $ad70bc77b98a9c8f$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $ad70bc77b98a9c8f$var$isEmptyData;

});

parcelRegister("5dlui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("bIXxp", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $8891fcbc5f9c05db$export$c7c5cef950a4d2fc; });

var $8P4uy = parcelRequire("8P4uy");

var $8yZXV = parcelRequire("8yZXV");
const $8891fcbc5f9c05db$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $8yZXV.fromUtf8)(input) : (0, $8P4uy.fromUtf8)(input);
const $8891fcbc5f9c05db$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $8yZXV.toUtf8)(input) : (0, $8P4uy.toUtf8)(input);

});
parcelRegister("8P4uy", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $66c6922739cd0dd8$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $66c6922739cd0dd8$export$b4b216764bb846eb; });
const $66c6922739cd0dd8$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $66c6922739cd0dd8$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("8yZXV", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $63c190c001a3cee5$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $63c190c001a3cee5$export$b4b216764bb846eb; });
function $63c190c001a3cee5$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $63c190c001a3cee5$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});


parcelRegister("4mzy7", function(module, exports) {

$parcel$export(module.exports, "locateWindow", function () { return $32d4cadb268cebeb$export$2a77db4d0e0dd1ff; });
const $32d4cadb268cebeb$var$fallbackWindow = {};
function $32d4cadb268cebeb$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $32d4cadb268cebeb$var$fallbackWindow;
}

});


parcelRegister("8Z2d1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $lasFd = parcelRequire("lasFd");

var $5dlui = parcelRequire("5dlui");

var $4mzy7 = parcelRequire("4mzy7");
var $68a5bbe7bb4adc9d$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(data) {
        if ((0, $lasFd.isEmptyData)(data)) return;
        var update = (0, $lasFd.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $4mzy7.locateWindow)().crypto.subtle.sign($5dlui.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $lasFd.isEmptyData)(this.toHash)) return Promise.resolve($5dlui.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $4mzy7.locateWindow)().crypto.subtle.digest($5dlui.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha256.prototype.reset = function() {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $4mzy7.locateWindow)().crypto.subtle.importKey("raw", (0, $lasFd.convertToBuffer)(_this.secret), $5dlui.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    };
    return Sha256;
}();
module.exports.Sha256 = $68a5bbe7bb4adc9d$var$Sha256;

});
parcelRegister("lasFd", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $eFxE8 = parcelRequire("eFxE8");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $eFxE8.convertToBuffer;
    }
});

var $aT3fx = parcelRequire("aT3fx");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $aT3fx.isEmptyData;
    }
});

var $hxvtA = parcelRequire("hxvtA");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $hxvtA.numToUint8;
    }
});

var $crAHy = parcelRequire("crAHy");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $crAHy.uint32ArrayFrom;
    }
});

});
parcelRegister("eFxE8", function(module, exports) {

var $if3aG = parcelRequire("if3aG");
var $aadefe80ab85e726$require$Buffer = $if3aG.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $bIXxp = parcelRequire("bIXxp");
// Quick polyfill
var $aadefe80ab85e726$var$fromUtf8 = typeof $aadefe80ab85e726$require$Buffer !== "undefined" && $aadefe80ab85e726$require$Buffer.from ? function(input) {
    return $aadefe80ab85e726$require$Buffer.from(input, "utf8");
} : $bIXxp.fromUtf8;
function $aadefe80ab85e726$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $aadefe80ab85e726$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $aadefe80ab85e726$var$convertToBuffer;

});
parcelRegister("if3aG", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d47c1671d6717f8e$export$a143d493d941bafc; }, function (v) { return $d47c1671d6717f8e$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d47c1671d6717f8e$export$f99ded8fe4b79145; }, function (v) { return $d47c1671d6717f8e$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d47c1671d6717f8e$export$a143d493d941bafc;
var $d47c1671d6717f8e$export$e4cf37d7f6fb9e0a;
var $d47c1671d6717f8e$export$f99ded8fe4b79145;
var $d47c1671d6717f8e$export$599f31c3813fae4d;
'use strict';

var $7hWVG = parcelRequire("7hWVG");

var $3osSG = parcelRequire("3osSG");
var $d47c1671d6717f8e$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d47c1671d6717f8e$export$a143d493d941bafc = $d47c1671d6717f8e$var$Buffer;
$d47c1671d6717f8e$export$e4cf37d7f6fb9e0a = $d47c1671d6717f8e$var$SlowBuffer;
$d47c1671d6717f8e$export$f99ded8fe4b79145 = 50;
var $d47c1671d6717f8e$var$K_MAX_LENGTH = 0x7fffffff;
$d47c1671d6717f8e$export$599f31c3813fae4d = $d47c1671d6717f8e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d47c1671d6717f8e$var$Buffer.TYPED_ARRAY_SUPPORT = $d47c1671d6717f8e$var$typedArraySupport();
if (!$d47c1671d6717f8e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d47c1671d6717f8e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d47c1671d6717f8e$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d47c1671d6717f8e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d47c1671d6717f8e$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d47c1671d6717f8e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d47c1671d6717f8e$var$createBuffer(length) {
    if (length > $d47c1671d6717f8e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d47c1671d6717f8e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d47c1671d6717f8e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d47c1671d6717f8e$var$allocUnsafe(arg);
    }
    return $d47c1671d6717f8e$var$from(arg, encodingOrOffset, length);
}
$d47c1671d6717f8e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d47c1671d6717f8e$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d47c1671d6717f8e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d47c1671d6717f8e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d47c1671d6717f8e$var$isInstance(value, ArrayBuffer) || value && $d47c1671d6717f8e$var$isInstance(value.buffer, ArrayBuffer)) return $d47c1671d6717f8e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d47c1671d6717f8e$var$isInstance(value, SharedArrayBuffer) || value && $d47c1671d6717f8e$var$isInstance(value.buffer, SharedArrayBuffer))) return $d47c1671d6717f8e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d47c1671d6717f8e$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d47c1671d6717f8e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d47c1671d6717f8e$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d47c1671d6717f8e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d47c1671d6717f8e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d47c1671d6717f8e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d47c1671d6717f8e$var$Buffer, Uint8Array);
function $d47c1671d6717f8e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d47c1671d6717f8e$var$alloc(size, fill, encoding) {
    $d47c1671d6717f8e$var$assertSize(size);
    if (size <= 0) return $d47c1671d6717f8e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d47c1671d6717f8e$var$createBuffer(size).fill(fill, encoding) : $d47c1671d6717f8e$var$createBuffer(size).fill(fill);
    return $d47c1671d6717f8e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d47c1671d6717f8e$var$Buffer.alloc = function(size, fill, encoding) {
    return $d47c1671d6717f8e$var$alloc(size, fill, encoding);
};
function $d47c1671d6717f8e$var$allocUnsafe(size) {
    $d47c1671d6717f8e$var$assertSize(size);
    return $d47c1671d6717f8e$var$createBuffer(size < 0 ? 0 : $d47c1671d6717f8e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d47c1671d6717f8e$var$Buffer.allocUnsafe = function(size) {
    return $d47c1671d6717f8e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d47c1671d6717f8e$var$Buffer.allocUnsafeSlow = function(size) {
    return $d47c1671d6717f8e$var$allocUnsafe(size);
};
function $d47c1671d6717f8e$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d47c1671d6717f8e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d47c1671d6717f8e$var$byteLength(string, encoding) | 0;
    var buf = $d47c1671d6717f8e$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d47c1671d6717f8e$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d47c1671d6717f8e$var$checked(array.length) | 0;
    var buf = $d47c1671d6717f8e$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d47c1671d6717f8e$var$fromArrayView(arrayView) {
    if ($d47c1671d6717f8e$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d47c1671d6717f8e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d47c1671d6717f8e$var$fromArrayLike(arrayView);
}
function $d47c1671d6717f8e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d47c1671d6717f8e$var$Buffer.prototype);
    return buf;
}
function $d47c1671d6717f8e$var$fromObject(obj) {
    if ($d47c1671d6717f8e$var$Buffer.isBuffer(obj)) {
        var len = $d47c1671d6717f8e$var$checked(obj.length) | 0;
        var buf = $d47c1671d6717f8e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d47c1671d6717f8e$var$numberIsNaN(obj.length)) return $d47c1671d6717f8e$var$createBuffer(0);
        return $d47c1671d6717f8e$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d47c1671d6717f8e$var$fromArrayLike(obj.data);
}
function $d47c1671d6717f8e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d47c1671d6717f8e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d47c1671d6717f8e$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d47c1671d6717f8e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d47c1671d6717f8e$var$Buffer.alloc(+length);
}
$d47c1671d6717f8e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d47c1671d6717f8e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d47c1671d6717f8e$var$Buffer.compare = function compare(a, b) {
    if ($d47c1671d6717f8e$var$isInstance(a, Uint8Array)) a = $d47c1671d6717f8e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d47c1671d6717f8e$var$isInstance(b, Uint8Array)) b = $d47c1671d6717f8e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d47c1671d6717f8e$var$Buffer.isBuffer(a) || !$d47c1671d6717f8e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d47c1671d6717f8e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d47c1671d6717f8e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d47c1671d6717f8e$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d47c1671d6717f8e$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d47c1671d6717f8e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d47c1671d6717f8e$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d47c1671d6717f8e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d47c1671d6717f8e$var$byteLength(string, encoding) {
    if ($d47c1671d6717f8e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d47c1671d6717f8e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d47c1671d6717f8e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d47c1671d6717f8e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d47c1671d6717f8e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d47c1671d6717f8e$var$Buffer.byteLength = $d47c1671d6717f8e$var$byteLength;
function $d47c1671d6717f8e$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d47c1671d6717f8e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d47c1671d6717f8e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d47c1671d6717f8e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d47c1671d6717f8e$var$latin1Slice(this, start, end);
        case 'base64':
            return $d47c1671d6717f8e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d47c1671d6717f8e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d47c1671d6717f8e$var$Buffer.prototype._isBuffer = true;
function $d47c1671d6717f8e$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d47c1671d6717f8e$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d47c1671d6717f8e$var$swap(this, i, i + 1);
    return this;
};
$d47c1671d6717f8e$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d47c1671d6717f8e$var$swap(this, i, i + 3);
        $d47c1671d6717f8e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d47c1671d6717f8e$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d47c1671d6717f8e$var$swap(this, i, i + 7);
        $d47c1671d6717f8e$var$swap(this, i + 1, i + 6);
        $d47c1671d6717f8e$var$swap(this, i + 2, i + 5);
        $d47c1671d6717f8e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d47c1671d6717f8e$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d47c1671d6717f8e$var$utf8Slice(this, 0, length);
    return $d47c1671d6717f8e$var$slowToString.apply(this, arguments);
};
$d47c1671d6717f8e$var$Buffer.prototype.toLocaleString = $d47c1671d6717f8e$var$Buffer.prototype.toString;
$d47c1671d6717f8e$var$Buffer.prototype.equals = function equals(b) {
    if (!$d47c1671d6717f8e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d47c1671d6717f8e$var$Buffer.compare(this, b) === 0;
};
$d47c1671d6717f8e$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d47c1671d6717f8e$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d47c1671d6717f8e$var$customInspectSymbol) $d47c1671d6717f8e$var$Buffer.prototype[$d47c1671d6717f8e$var$customInspectSymbol] = $d47c1671d6717f8e$var$Buffer.prototype.inspect;
$d47c1671d6717f8e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d47c1671d6717f8e$var$isInstance(target, Uint8Array)) target = $d47c1671d6717f8e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d47c1671d6717f8e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d47c1671d6717f8e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d47c1671d6717f8e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d47c1671d6717f8e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d47c1671d6717f8e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d47c1671d6717f8e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d47c1671d6717f8e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d47c1671d6717f8e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d47c1671d6717f8e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d47c1671d6717f8e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d47c1671d6717f8e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d47c1671d6717f8e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d47c1671d6717f8e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d47c1671d6717f8e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d47c1671d6717f8e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d47c1671d6717f8e$var$utf8Write(buf, string, offset, length) {
    return $d47c1671d6717f8e$var$blitBuffer($d47c1671d6717f8e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d47c1671d6717f8e$var$asciiWrite(buf, string, offset, length) {
    return $d47c1671d6717f8e$var$blitBuffer($d47c1671d6717f8e$var$asciiToBytes(string), buf, offset, length);
}
function $d47c1671d6717f8e$var$base64Write(buf, string, offset, length) {
    return $d47c1671d6717f8e$var$blitBuffer($d47c1671d6717f8e$var$base64ToBytes(string), buf, offset, length);
}
function $d47c1671d6717f8e$var$ucs2Write(buf, string, offset, length) {
    return $d47c1671d6717f8e$var$blitBuffer($d47c1671d6717f8e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d47c1671d6717f8e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d47c1671d6717f8e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d47c1671d6717f8e$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d47c1671d6717f8e$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d47c1671d6717f8e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d47c1671d6717f8e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d47c1671d6717f8e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d47c1671d6717f8e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7hWVG.fromByteArray(buf);
    else return $7hWVG.fromByteArray(buf.slice(start, end));
}
function $d47c1671d6717f8e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d47c1671d6717f8e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d47c1671d6717f8e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d47c1671d6717f8e$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d47c1671d6717f8e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d47c1671d6717f8e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d47c1671d6717f8e$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d47c1671d6717f8e$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d47c1671d6717f8e$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d47c1671d6717f8e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d47c1671d6717f8e$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d47c1671d6717f8e$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d47c1671d6717f8e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d47c1671d6717f8e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d47c1671d6717f8e$var$Buffer.prototype.readUintLE = $d47c1671d6717f8e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d47c1671d6717f8e$var$Buffer.prototype.readUintBE = $d47c1671d6717f8e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d47c1671d6717f8e$var$Buffer.prototype.readUint8 = $d47c1671d6717f8e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d47c1671d6717f8e$var$Buffer.prototype.readUint16LE = $d47c1671d6717f8e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d47c1671d6717f8e$var$Buffer.prototype.readUint16BE = $d47c1671d6717f8e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d47c1671d6717f8e$var$Buffer.prototype.readUint32LE = $d47c1671d6717f8e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d47c1671d6717f8e$var$Buffer.prototype.readUint32BE = $d47c1671d6717f8e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d47c1671d6717f8e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d47c1671d6717f8e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d47c1671d6717f8e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d47c1671d6717f8e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d47c1671d6717f8e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d47c1671d6717f8e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d47c1671d6717f8e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d47c1671d6717f8e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 4, this.length);
    return $3osSG.read(this, offset, true, 23, 4);
};
$d47c1671d6717f8e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 4, this.length);
    return $3osSG.read(this, offset, false, 23, 4);
};
$d47c1671d6717f8e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 8, this.length);
    return $3osSG.read(this, offset, true, 52, 8);
};
$d47c1671d6717f8e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkOffset(offset, 8, this.length);
    return $3osSG.read(this, offset, false, 52, 8);
};
function $d47c1671d6717f8e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d47c1671d6717f8e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d47c1671d6717f8e$var$Buffer.prototype.writeUintLE = $d47c1671d6717f8e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d47c1671d6717f8e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeUintBE = $d47c1671d6717f8e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d47c1671d6717f8e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeUint8 = $d47c1671d6717f8e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeUint16LE = $d47c1671d6717f8e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeUint16BE = $d47c1671d6717f8e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeUint32LE = $d47c1671d6717f8e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeUint32BE = $d47c1671d6717f8e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d47c1671d6717f8e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d47c1671d6717f8e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d47c1671d6717f8e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d47c1671d6717f8e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d47c1671d6717f8e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $3osSG.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d47c1671d6717f8e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d47c1671d6717f8e$var$writeFloat(this, value, offset, true, noAssert);
};
$d47c1671d6717f8e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d47c1671d6717f8e$var$writeFloat(this, value, offset, false, noAssert);
};
function $d47c1671d6717f8e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d47c1671d6717f8e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $3osSG.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d47c1671d6717f8e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d47c1671d6717f8e$var$writeDouble(this, value, offset, true, noAssert);
};
$d47c1671d6717f8e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d47c1671d6717f8e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d47c1671d6717f8e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d47c1671d6717f8e$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d47c1671d6717f8e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d47c1671d6717f8e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d47c1671d6717f8e$var$Buffer.isBuffer(val) ? val : $d47c1671d6717f8e$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d47c1671d6717f8e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d47c1671d6717f8e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d47c1671d6717f8e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d47c1671d6717f8e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d47c1671d6717f8e$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d47c1671d6717f8e$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d47c1671d6717f8e$var$base64ToBytes(str) {
    return $7hWVG.toByteArray($d47c1671d6717f8e$var$base64clean(str));
}
function $d47c1671d6717f8e$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d47c1671d6717f8e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d47c1671d6717f8e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d47c1671d6717f8e$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("7hWVG", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $54e7d51b26a201dc$export$d622b2ad8d90c771; }, function (v) { return $54e7d51b26a201dc$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $54e7d51b26a201dc$export$6100ba28696e12de; }, function (v) { return $54e7d51b26a201dc$export$6100ba28696e12de = v; });
var $54e7d51b26a201dc$export$a48f0734ac7c2329;
var $54e7d51b26a201dc$export$d622b2ad8d90c771;
var $54e7d51b26a201dc$export$6100ba28696e12de;
'use strict';
$54e7d51b26a201dc$export$a48f0734ac7c2329 = $54e7d51b26a201dc$var$byteLength;
$54e7d51b26a201dc$export$d622b2ad8d90c771 = $54e7d51b26a201dc$var$toByteArray;
$54e7d51b26a201dc$export$6100ba28696e12de = $54e7d51b26a201dc$var$fromByteArray;
var $54e7d51b26a201dc$var$lookup = [];
var $54e7d51b26a201dc$var$revLookup = [];
var $54e7d51b26a201dc$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $54e7d51b26a201dc$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $54e7d51b26a201dc$var$i = 0, $54e7d51b26a201dc$var$len = $54e7d51b26a201dc$var$code.length; $54e7d51b26a201dc$var$i < $54e7d51b26a201dc$var$len; ++$54e7d51b26a201dc$var$i){
    $54e7d51b26a201dc$var$lookup[$54e7d51b26a201dc$var$i] = $54e7d51b26a201dc$var$code[$54e7d51b26a201dc$var$i];
    $54e7d51b26a201dc$var$revLookup[$54e7d51b26a201dc$var$code.charCodeAt($54e7d51b26a201dc$var$i)] = $54e7d51b26a201dc$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$54e7d51b26a201dc$var$revLookup['-'.charCodeAt(0)] = 62;
$54e7d51b26a201dc$var$revLookup['_'.charCodeAt(0)] = 63;
function $54e7d51b26a201dc$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $54e7d51b26a201dc$var$byteLength(b64) {
    var lens = $54e7d51b26a201dc$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $54e7d51b26a201dc$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $54e7d51b26a201dc$var$toByteArray(b64) {
    var tmp;
    var lens = $54e7d51b26a201dc$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $54e7d51b26a201dc$var$Arr($54e7d51b26a201dc$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i)] << 18 | $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i)] << 2 | $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i)] << 10 | $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $54e7d51b26a201dc$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $54e7d51b26a201dc$var$tripletToBase64(num) {
    return $54e7d51b26a201dc$var$lookup[num >> 18 & 0x3F] + $54e7d51b26a201dc$var$lookup[num >> 12 & 0x3F] + $54e7d51b26a201dc$var$lookup[num >> 6 & 0x3F] + $54e7d51b26a201dc$var$lookup[num & 0x3F];
}
function $54e7d51b26a201dc$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($54e7d51b26a201dc$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $54e7d51b26a201dc$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($54e7d51b26a201dc$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($54e7d51b26a201dc$var$lookup[tmp >> 2] + $54e7d51b26a201dc$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($54e7d51b26a201dc$var$lookup[tmp >> 10] + $54e7d51b26a201dc$var$lookup[tmp >> 4 & 0x3F] + $54e7d51b26a201dc$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("3osSG", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $278a0427da1b0cdd$export$aafa59e2e03f2942; }, function (v) { return $278a0427da1b0cdd$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $278a0427da1b0cdd$export$68d8715fc104d294; }, function (v) { return $278a0427da1b0cdd$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $278a0427da1b0cdd$export$aafa59e2e03f2942;
var $278a0427da1b0cdd$export$68d8715fc104d294;
$278a0427da1b0cdd$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$278a0427da1b0cdd$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("aT3fx", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $7ed18fc41ef48445$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $7ed18fc41ef48445$var$isEmptyData;

});

parcelRegister("hxvtA", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $cc4def43a635c203$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $cc4def43a635c203$var$numToUint8;

});

parcelRegister("crAHy", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $90f479c7fb617b53$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $90f479c7fb617b53$var$uint32ArrayFrom;

});



parcelRegister("5IU1g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aja4K = parcelRequire("aja4K");

$aja4K.__exportStar((parcelRequire("iLiwn")), module.exports);

});
parcelRegister("aja4K", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $78137e8a7eb760d1$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $78137e8a7eb760d1$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $78137e8a7eb760d1$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $78137e8a7eb760d1$var$extendStatics = function(d, b) {
    $78137e8a7eb760d1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $78137e8a7eb760d1$var$extendStatics(d, b);
};
function $78137e8a7eb760d1$export$a8ba968b8961cb8a(d, b) {
    $78137e8a7eb760d1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $78137e8a7eb760d1$export$18ce0697a983be9b = function() {
    $78137e8a7eb760d1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $78137e8a7eb760d1$export$18ce0697a983be9b.apply(this, arguments);
};
function $78137e8a7eb760d1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $78137e8a7eb760d1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $78137e8a7eb760d1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $78137e8a7eb760d1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $78137e8a7eb760d1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $78137e8a7eb760d1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $78137e8a7eb760d1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $78137e8a7eb760d1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $78137e8a7eb760d1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $78137e8a7eb760d1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $78137e8a7eb760d1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($78137e8a7eb760d1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $78137e8a7eb760d1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $78137e8a7eb760d1$export$10c90e4f7922046c(v) {
    return this instanceof $78137e8a7eb760d1$export$10c90e4f7922046c ? (this.v = v, this) : new $78137e8a7eb760d1$export$10c90e4f7922046c(v);
}
function $78137e8a7eb760d1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $78137e8a7eb760d1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $78137e8a7eb760d1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $78137e8a7eb760d1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $78137e8a7eb760d1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $78137e8a7eb760d1$export$19a8beecd37a4c45 === "function" ? $78137e8a7eb760d1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $78137e8a7eb760d1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $78137e8a7eb760d1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $78137e8a7eb760d1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $78137e8a7eb760d1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $78137e8a7eb760d1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("iLiwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $aja4K = parcelRequire("aja4K");

var $jRAbF = parcelRequire("jRAbF");

var $hnCv6 = parcelRequire("hnCv6");

var $lasFd = parcelRequire("lasFd");
var $da8afbba74987e58$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new $hnCv6.RawSha256();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $lasFd.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $lasFd.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $aja4K.__awaiter(this, void 0, void 0, function() {
            return $aja4K.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new $hnCv6.RawSha256();
        if (this.secret) {
            this.outer = new $hnCv6.RawSha256();
            var inner = $da8afbba74987e58$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array($jRAbF.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $jRAbF.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
module.exports.Sha256 = $da8afbba74987e58$var$Sha256;
function $da8afbba74987e58$var$bufferFromSecret(secret) {
    var input = (0, $lasFd.convertToBuffer)(secret);
    if (input.byteLength > $jRAbF.BLOCK_SIZE) {
        var bufferHash = new $hnCv6.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($jRAbF.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("jRAbF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("hnCv6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $jRAbF = parcelRequire("jRAbF");
/**
 * @internal
 */ var $ca72731588b144dd$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($jRAbF.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $jRAbF.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $jRAbF.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $jRAbF.BLOCK_SIZE >= $jRAbF.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $jRAbF.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $jRAbF.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($jRAbF.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($jRAbF.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($jRAbF.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $jRAbF.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($jRAbF.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $ca72731588b144dd$var$RawSha256;

});



parcelRegister("3jiis", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aja4K = parcelRequire("aja4K");

$aja4K.__exportStar((parcelRequire("7r77Y")), module.exports);

});
parcelRegister("7r77Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $aja4K = parcelRequire("aja4K");
var $56a09563fd22cf74$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $56a09563fd22cf74$var$supportsWebCrypto(window) {
    if ($56a09563fd22cf74$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $56a09563fd22cf74$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $56a09563fd22cf74$var$supportsWebCrypto;
function $56a09563fd22cf74$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $56a09563fd22cf74$var$supportsSecureRandom;
function $56a09563fd22cf74$var$supportsSubtleCrypto(subtle) {
    return subtle && $56a09563fd22cf74$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $56a09563fd22cf74$var$supportsSubtleCrypto;
function $56a09563fd22cf74$var$supportsZeroByteGCM(subtle) {
    return $aja4K.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return $aja4K.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$56a09563fd22cf74$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $56a09563fd22cf74$var$supportsZeroByteGCM;

});


parcelRegister("4VfP7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aja4K = parcelRequire("aja4K");

$aja4K.__exportStar((parcelRequire("5IFhc")), module.exports);

$aja4K.__exportStar((parcelRequire("1c6zg")), module.exports);

$aja4K.__exportStar((parcelRequire("6nSTe")), module.exports);

$aja4K.__exportStar((parcelRequire("hqN0S")), module.exports);

$aja4K.__exportStar((parcelRequire("fN5pF")), module.exports);

});
parcelRegister("5IFhc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1c6zg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6nSTe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hqN0S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fN5pF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $b7efa18076593304$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $b7efa18076593304$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $b7efa18076593304$var$isMsWindow(window) {
    if ($b7efa18076593304$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $b7efa18076593304$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $b7efa18076593304$var$isMsWindow;

});




var $cc8500bd1d8c4094$exports = {};
"use strict";
Object.defineProperty($cc8500bd1d8c4094$exports, "__esModule", {
    value: true
});
$cc8500bd1d8c4094$exports.WebCryptoSha256 = $cc8500bd1d8c4094$exports.Ie11Sha256 = void 0;

var $aja4K = parcelRequire("aja4K");

$aja4K.__exportStar((parcelRequire("cJjDV")), $cc8500bd1d8c4094$exports);

var $emEpv = parcelRequire("emEpv");
Object.defineProperty($cc8500bd1d8c4094$exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $emEpv.Sha256;
    }
});

var $8Z2d1 = parcelRequire("8Z2d1");
Object.defineProperty($cc8500bd1d8c4094$exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $8Z2d1.Sha256;
    }
});


// packages/alpinejs/src/scheduler.js
var $83ff99eb528b29b5$var$flushPending = false;
var $83ff99eb528b29b5$var$flushing = false;
var $83ff99eb528b29b5$var$queue = [];
var $83ff99eb528b29b5$var$lastFlushedIndex = -1;
function $83ff99eb528b29b5$var$scheduler(callback) {
    $83ff99eb528b29b5$var$queueJob(callback);
}
function $83ff99eb528b29b5$var$queueJob(job) {
    if (!$83ff99eb528b29b5$var$queue.includes(job)) $83ff99eb528b29b5$var$queue.push(job);
    $83ff99eb528b29b5$var$queueFlush();
}
function $83ff99eb528b29b5$var$dequeueJob(job) {
    let index = $83ff99eb528b29b5$var$queue.indexOf(job);
    if (index !== -1 && index > $83ff99eb528b29b5$var$lastFlushedIndex) $83ff99eb528b29b5$var$queue.splice(index, 1);
}
function $83ff99eb528b29b5$var$queueFlush() {
    if (!$83ff99eb528b29b5$var$flushing && !$83ff99eb528b29b5$var$flushPending) {
        $83ff99eb528b29b5$var$flushPending = true;
        queueMicrotask($83ff99eb528b29b5$var$flushJobs);
    }
}
function $83ff99eb528b29b5$var$flushJobs() {
    $83ff99eb528b29b5$var$flushPending = false;
    $83ff99eb528b29b5$var$flushing = true;
    for(let i = 0; i < $83ff99eb528b29b5$var$queue.length; i++){
        $83ff99eb528b29b5$var$queue[i]();
        $83ff99eb528b29b5$var$lastFlushedIndex = i;
    }
    $83ff99eb528b29b5$var$queue.length = 0;
    $83ff99eb528b29b5$var$lastFlushedIndex = -1;
    $83ff99eb528b29b5$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $83ff99eb528b29b5$var$reactive;
var $83ff99eb528b29b5$var$effect;
var $83ff99eb528b29b5$var$release;
var $83ff99eb528b29b5$var$raw;
var $83ff99eb528b29b5$var$shouldSchedule = true;
function $83ff99eb528b29b5$var$disableEffectScheduling(callback) {
    $83ff99eb528b29b5$var$shouldSchedule = false;
    callback();
    $83ff99eb528b29b5$var$shouldSchedule = true;
}
function $83ff99eb528b29b5$var$setReactivityEngine(engine) {
    $83ff99eb528b29b5$var$reactive = engine.reactive;
    $83ff99eb528b29b5$var$release = engine.release;
    $83ff99eb528b29b5$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($83ff99eb528b29b5$var$shouldSchedule) $83ff99eb528b29b5$var$scheduler(task);
                else task();
            }
        });
    $83ff99eb528b29b5$var$raw = engine.raw;
}
function $83ff99eb528b29b5$var$overrideEffect(override) {
    $83ff99eb528b29b5$var$effect = override;
}
function $83ff99eb528b29b5$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $83ff99eb528b29b5$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $83ff99eb528b29b5$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $83ff99eb528b29b5$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $83ff99eb528b29b5$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$83ff99eb528b29b5$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $83ff99eb528b29b5$var$onAttributeAddeds = [];
var $83ff99eb528b29b5$var$onElRemoveds = [];
var $83ff99eb528b29b5$var$onElAddeds = [];
function $83ff99eb528b29b5$var$onElAdded(callback) {
    $83ff99eb528b29b5$var$onElAddeds.push(callback);
}
function $83ff99eb528b29b5$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $83ff99eb528b29b5$var$onElRemoveds.push(callback);
    }
}
function $83ff99eb528b29b5$var$onAttributesAdded(callback) {
    $83ff99eb528b29b5$var$onAttributeAddeds.push(callback);
}
function $83ff99eb528b29b5$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $83ff99eb528b29b5$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $83ff99eb528b29b5$var$cleanupElement(el) {
    el._x_effects?.forEach($83ff99eb528b29b5$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $83ff99eb528b29b5$var$observer = new MutationObserver($83ff99eb528b29b5$var$onMutate);
var $83ff99eb528b29b5$var$currentlyObserving = false;
function $83ff99eb528b29b5$var$startObservingMutations() {
    $83ff99eb528b29b5$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $83ff99eb528b29b5$var$currentlyObserving = true;
}
function $83ff99eb528b29b5$var$stopObservingMutations() {
    $83ff99eb528b29b5$var$flushObserver();
    $83ff99eb528b29b5$var$observer.disconnect();
    $83ff99eb528b29b5$var$currentlyObserving = false;
}
var $83ff99eb528b29b5$var$queuedMutations = [];
function $83ff99eb528b29b5$var$flushObserver() {
    let records = $83ff99eb528b29b5$var$observer.takeRecords();
    $83ff99eb528b29b5$var$queuedMutations.push(()=>records.length > 0 && $83ff99eb528b29b5$var$onMutate(records));
    let queueLengthWhenTriggered = $83ff99eb528b29b5$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($83ff99eb528b29b5$var$queuedMutations.length === queueLengthWhenTriggered) while($83ff99eb528b29b5$var$queuedMutations.length > 0)$83ff99eb528b29b5$var$queuedMutations.shift()();
    });
}
function $83ff99eb528b29b5$var$mutateDom(callback) {
    if (!$83ff99eb528b29b5$var$currentlyObserving) return callback();
    $83ff99eb528b29b5$var$stopObservingMutations();
    let result = callback();
    $83ff99eb528b29b5$var$startObservingMutations();
    return result;
}
var $83ff99eb528b29b5$var$isCollecting = false;
var $83ff99eb528b29b5$var$deferredMutations = [];
function $83ff99eb528b29b5$var$deferMutations() {
    $83ff99eb528b29b5$var$isCollecting = true;
}
function $83ff99eb528b29b5$var$flushAndStopDeferringMutations() {
    $83ff99eb528b29b5$var$isCollecting = false;
    $83ff99eb528b29b5$var$onMutate($83ff99eb528b29b5$var$deferredMutations);
    $83ff99eb528b29b5$var$deferredMutations = [];
}
function $83ff99eb528b29b5$var$onMutate(mutations) {
    if ($83ff99eb528b29b5$var$isCollecting) {
        $83ff99eb528b29b5$var$deferredMutations = $83ff99eb528b29b5$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $83ff99eb528b29b5$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $83ff99eb528b29b5$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $83ff99eb528b29b5$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $83ff99eb528b29b5$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $83ff99eb528b29b5$var$scope(node) {
    return $83ff99eb528b29b5$var$mergeProxies($83ff99eb528b29b5$var$closestDataStack(node));
}
function $83ff99eb528b29b5$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$83ff99eb528b29b5$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $83ff99eb528b29b5$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $83ff99eb528b29b5$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $83ff99eb528b29b5$var$closestDataStack(node.parentNode);
}
function $83ff99eb528b29b5$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $83ff99eb528b29b5$var$mergeProxyTrap);
}
var $83ff99eb528b29b5$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $83ff99eb528b29b5$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $83ff99eb528b29b5$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $83ff99eb528b29b5$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $83ff99eb528b29b5$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$83ff99eb528b29b5$var$get(data2, path), (value)=>$83ff99eb528b29b5$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $83ff99eb528b29b5$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $83ff99eb528b29b5$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $83ff99eb528b29b5$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $83ff99eb528b29b5$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $83ff99eb528b29b5$var$magics = {};
function $83ff99eb528b29b5$var$magic(name, callback) {
    $83ff99eb528b29b5$var$magics[name] = callback;
}
function $83ff99eb528b29b5$var$injectMagics(obj, el) {
    let memoizedUtilities = $83ff99eb528b29b5$var$getUtilities(el);
    Object.entries($83ff99eb528b29b5$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $83ff99eb528b29b5$var$getUtilities(el) {
    let [utilities, cleanup2] = $83ff99eb528b29b5$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $83ff99eb528b29b5$var$interceptor,
        ...utilities
    };
    $83ff99eb528b29b5$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $83ff99eb528b29b5$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $83ff99eb528b29b5$var$handleError(e, el, expression);
    }
}
function $83ff99eb528b29b5$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $83ff99eb528b29b5$var$shouldAutoEvaluateFunctions = true;
function $83ff99eb528b29b5$var$dontAutoEvaluateFunctions(callback) {
    let cache = $83ff99eb528b29b5$var$shouldAutoEvaluateFunctions;
    $83ff99eb528b29b5$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $83ff99eb528b29b5$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $83ff99eb528b29b5$var$evaluate(el, expression, extras = {}) {
    let result;
    $83ff99eb528b29b5$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $83ff99eb528b29b5$var$evaluateLater(...args) {
    return $83ff99eb528b29b5$var$theEvaluatorFunction(...args);
}
var $83ff99eb528b29b5$var$theEvaluatorFunction = $83ff99eb528b29b5$var$normalEvaluator;
function $83ff99eb528b29b5$var$setEvaluator(newEvaluator) {
    $83ff99eb528b29b5$var$theEvaluatorFunction = newEvaluator;
}
function $83ff99eb528b29b5$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $83ff99eb528b29b5$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$83ff99eb528b29b5$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $83ff99eb528b29b5$var$generateEvaluatorFromFunction(dataStack, expression) : $83ff99eb528b29b5$var$generateEvaluatorFromString(dataStack, expression, el);
    return $83ff99eb528b29b5$var$tryCatch.bind(null, el, expression, evaluator);
}
function $83ff99eb528b29b5$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($83ff99eb528b29b5$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $83ff99eb528b29b5$var$runIfTypeOfFunction(receiver, result);
    };
}
var $83ff99eb528b29b5$var$evaluatorMemo = {};
function $83ff99eb528b29b5$var$generateFunctionFromString(expression, el) {
    if ($83ff99eb528b29b5$var$evaluatorMemo[expression]) return $83ff99eb528b29b5$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $83ff99eb528b29b5$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $83ff99eb528b29b5$var$evaluatorMemo[expression] = func;
    return func;
}
function $83ff99eb528b29b5$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $83ff99eb528b29b5$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $83ff99eb528b29b5$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$83ff99eb528b29b5$var$handleError(error2, el, expression));
            if (func.finished) {
                $83ff99eb528b29b5$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $83ff99eb528b29b5$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$83ff99eb528b29b5$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $83ff99eb528b29b5$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($83ff99eb528b29b5$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$83ff99eb528b29b5$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$83ff99eb528b29b5$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $83ff99eb528b29b5$var$prefixAsString = "x-";
function $83ff99eb528b29b5$var$prefix(subject = "") {
    return $83ff99eb528b29b5$var$prefixAsString + subject;
}
function $83ff99eb528b29b5$var$setPrefix(newPrefix) {
    $83ff99eb528b29b5$var$prefixAsString = newPrefix;
}
var $83ff99eb528b29b5$var$directiveHandlers = {};
function $83ff99eb528b29b5$var$directive(name, callback) {
    $83ff99eb528b29b5$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$83ff99eb528b29b5$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $83ff99eb528b29b5$var$directiveOrder.indexOf(directive2);
            $83ff99eb528b29b5$var$directiveOrder.splice(pos >= 0 ? pos : $83ff99eb528b29b5$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $83ff99eb528b29b5$var$directiveExists(name) {
    return Object.keys($83ff99eb528b29b5$var$directiveHandlers).includes(name);
}
function $83ff99eb528b29b5$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $83ff99eb528b29b5$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($83ff99eb528b29b5$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($83ff99eb528b29b5$var$outNonAlpineAttributes).map($83ff99eb528b29b5$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($83ff99eb528b29b5$var$byPriority);
    return directives2.map((directive2)=>{
        return $83ff99eb528b29b5$var$getDirectiveHandler(el, directive2);
    });
}
function $83ff99eb528b29b5$var$attributesOnly(attributes) {
    return Array.from(attributes).map($83ff99eb528b29b5$var$toTransformedAttributes()).filter((attr)=>!$83ff99eb528b29b5$var$outNonAlpineAttributes(attr));
}
var $83ff99eb528b29b5$var$isDeferringHandlers = false;
var $83ff99eb528b29b5$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $83ff99eb528b29b5$var$currentHandlerStackKey = Symbol();
function $83ff99eb528b29b5$var$deferHandlingDirectives(callback) {
    $83ff99eb528b29b5$var$isDeferringHandlers = true;
    let key = Symbol();
    $83ff99eb528b29b5$var$currentHandlerStackKey = key;
    $83ff99eb528b29b5$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($83ff99eb528b29b5$var$directiveHandlerStacks.get(key).length)$83ff99eb528b29b5$var$directiveHandlerStacks.get(key).shift()();
        $83ff99eb528b29b5$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $83ff99eb528b29b5$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $83ff99eb528b29b5$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $83ff99eb528b29b5$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $83ff99eb528b29b5$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $83ff99eb528b29b5$var$evaluateLater.bind($83ff99eb528b29b5$var$evaluateLater, el),
        evaluate: $83ff99eb528b29b5$var$evaluate.bind($83ff99eb528b29b5$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $83ff99eb528b29b5$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $83ff99eb528b29b5$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $83ff99eb528b29b5$var$getElementBoundUtilities(el);
    $83ff99eb528b29b5$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $83ff99eb528b29b5$var$isDeferringHandlers ? $83ff99eb528b29b5$var$directiveHandlerStacks.get($83ff99eb528b29b5$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $83ff99eb528b29b5$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $83ff99eb528b29b5$var$into = (i)=>i;
function $83ff99eb528b29b5$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $83ff99eb528b29b5$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $83ff99eb528b29b5$var$attributeTransformers = [];
function $83ff99eb528b29b5$var$mapAttributes(callback) {
    $83ff99eb528b29b5$var$attributeTransformers.push(callback);
}
function $83ff99eb528b29b5$var$outNonAlpineAttributes({ name: name }) {
    return $83ff99eb528b29b5$var$alpineAttributeRegex().test(name);
}
var $83ff99eb528b29b5$var$alpineAttributeRegex = ()=>new RegExp(`^${$83ff99eb528b29b5$var$prefixAsString}([^:^.]+)\\b`);
function $83ff99eb528b29b5$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($83ff99eb528b29b5$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $83ff99eb528b29b5$var$DEFAULT = "DEFAULT";
var $83ff99eb528b29b5$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $83ff99eb528b29b5$var$DEFAULT,
    "teleport"
];
function $83ff99eb528b29b5$var$byPriority(a, b) {
    let typeA = $83ff99eb528b29b5$var$directiveOrder.indexOf(a.type) === -1 ? $83ff99eb528b29b5$var$DEFAULT : a.type;
    let typeB = $83ff99eb528b29b5$var$directiveOrder.indexOf(b.type) === -1 ? $83ff99eb528b29b5$var$DEFAULT : b.type;
    return $83ff99eb528b29b5$var$directiveOrder.indexOf(typeA) - $83ff99eb528b29b5$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $83ff99eb528b29b5$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $83ff99eb528b29b5$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$83ff99eb528b29b5$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $83ff99eb528b29b5$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $83ff99eb528b29b5$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $83ff99eb528b29b5$var$started = false;
function $83ff99eb528b29b5$var$start() {
    if ($83ff99eb528b29b5$var$started) $83ff99eb528b29b5$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $83ff99eb528b29b5$var$started = true;
    if (!document.body) $83ff99eb528b29b5$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $83ff99eb528b29b5$var$dispatch(document, "alpine:init");
    $83ff99eb528b29b5$var$dispatch(document, "alpine:initializing");
    $83ff99eb528b29b5$var$startObservingMutations();
    $83ff99eb528b29b5$var$onElAdded((el)=>$83ff99eb528b29b5$var$initTree(el, $83ff99eb528b29b5$var$walk));
    $83ff99eb528b29b5$var$onElRemoved((el)=>$83ff99eb528b29b5$var$destroyTree(el));
    $83ff99eb528b29b5$var$onAttributesAdded((el, attrs)=>{
        $83ff99eb528b29b5$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$83ff99eb528b29b5$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($83ff99eb528b29b5$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $83ff99eb528b29b5$var$initTree(el);
    });
    $83ff99eb528b29b5$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $83ff99eb528b29b5$var$warnAboutMissingPlugins();
    });
}
var $83ff99eb528b29b5$var$rootSelectorCallbacks = [];
var $83ff99eb528b29b5$var$initSelectorCallbacks = [];
function $83ff99eb528b29b5$var$rootSelectors() {
    return $83ff99eb528b29b5$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $83ff99eb528b29b5$var$allSelectors() {
    return $83ff99eb528b29b5$var$rootSelectorCallbacks.concat($83ff99eb528b29b5$var$initSelectorCallbacks).map((fn)=>fn());
}
function $83ff99eb528b29b5$var$addRootSelector(selectorCallback) {
    $83ff99eb528b29b5$var$rootSelectorCallbacks.push(selectorCallback);
}
function $83ff99eb528b29b5$var$addInitSelector(selectorCallback) {
    $83ff99eb528b29b5$var$initSelectorCallbacks.push(selectorCallback);
}
function $83ff99eb528b29b5$var$closestRoot(el, includeInitSelectors = false) {
    return $83ff99eb528b29b5$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $83ff99eb528b29b5$var$allSelectors() : $83ff99eb528b29b5$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $83ff99eb528b29b5$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $83ff99eb528b29b5$var$findClosest(el.parentElement, callback);
}
function $83ff99eb528b29b5$var$isRoot(el) {
    return $83ff99eb528b29b5$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $83ff99eb528b29b5$var$initInterceptors2 = [];
function $83ff99eb528b29b5$var$interceptInit(callback) {
    $83ff99eb528b29b5$var$initInterceptors2.push(callback);
}
var $83ff99eb528b29b5$var$markerDispenser = 1;
function $83ff99eb528b29b5$var$initTree(el, walker = $83ff99eb528b29b5$var$walk, intercept = ()=>{}) {
    if ($83ff99eb528b29b5$var$findClosest(el, (i)=>i._x_ignore)) return;
    $83ff99eb528b29b5$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $83ff99eb528b29b5$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $83ff99eb528b29b5$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $83ff99eb528b29b5$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $83ff99eb528b29b5$var$destroyTree(root, walker = $83ff99eb528b29b5$var$walk) {
    walker(root, (el)=>{
        $83ff99eb528b29b5$var$cleanupElement(el);
        $83ff99eb528b29b5$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $83ff99eb528b29b5$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($83ff99eb528b29b5$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $83ff99eb528b29b5$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $83ff99eb528b29b5$var$tickStack = [];
var $83ff99eb528b29b5$var$isHolding = false;
function $83ff99eb528b29b5$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $83ff99eb528b29b5$var$isHolding || setTimeout(()=>{
            $83ff99eb528b29b5$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $83ff99eb528b29b5$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $83ff99eb528b29b5$var$releaseNextTicks() {
    $83ff99eb528b29b5$var$isHolding = false;
    while($83ff99eb528b29b5$var$tickStack.length)$83ff99eb528b29b5$var$tickStack.shift()();
}
function $83ff99eb528b29b5$var$holdNextTicks() {
    $83ff99eb528b29b5$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $83ff99eb528b29b5$var$setClasses(el, value) {
    if (Array.isArray(value)) return $83ff99eb528b29b5$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $83ff99eb528b29b5$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $83ff99eb528b29b5$var$setClasses(el, value());
    return $83ff99eb528b29b5$var$setClassesFromString(el, value);
}
function $83ff99eb528b29b5$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $83ff99eb528b29b5$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $83ff99eb528b29b5$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $83ff99eb528b29b5$var$setStylesFromObject(el, value);
    return $83ff99eb528b29b5$var$setStylesFromString(el, value);
}
function $83ff99eb528b29b5$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $83ff99eb528b29b5$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $83ff99eb528b29b5$var$setStyles(el, previousStyles);
    };
}
function $83ff99eb528b29b5$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $83ff99eb528b29b5$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $83ff99eb528b29b5$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$83ff99eb528b29b5$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $83ff99eb528b29b5$var$registerTransitionsFromHelper(el, modifiers, value);
    else $83ff99eb528b29b5$var$registerTransitionsFromClassString(el, expression, value);
});
function $83ff99eb528b29b5$var$registerTransitionsFromClassString(el, classString, stage) {
    $83ff99eb528b29b5$var$registerTransitionObject(el, $83ff99eb528b29b5$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $83ff99eb528b29b5$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $83ff99eb528b29b5$var$registerTransitionObject(el, $83ff99eb528b29b5$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $83ff99eb528b29b5$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $83ff99eb528b29b5$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $83ff99eb528b29b5$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $83ff99eb528b29b5$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $83ff99eb528b29b5$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $83ff99eb528b29b5$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $83ff99eb528b29b5$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $83ff99eb528b29b5$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $83ff99eb528b29b5$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $83ff99eb528b29b5$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $83ff99eb528b29b5$var$closestHide(parent);
}
function $83ff99eb528b29b5$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $83ff99eb528b29b5$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $83ff99eb528b29b5$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $83ff99eb528b29b5$var$once(()=>{
        $83ff99eb528b29b5$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $83ff99eb528b29b5$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $83ff99eb528b29b5$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $83ff99eb528b29b5$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $83ff99eb528b29b5$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $83ff99eb528b29b5$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $83ff99eb528b29b5$var$mutateDom(()=>{
                stages.end();
            });
            $83ff99eb528b29b5$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $83ff99eb528b29b5$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $83ff99eb528b29b5$var$isCloning = false;
function $83ff99eb528b29b5$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$83ff99eb528b29b5$var$isCloning ? fallback(...args) : callback(...args);
}
function $83ff99eb528b29b5$var$onlyDuringClone(callback) {
    return (...args)=>$83ff99eb528b29b5$var$isCloning && callback(...args);
}
var $83ff99eb528b29b5$var$interceptors = [];
function $83ff99eb528b29b5$var$interceptClone(callback) {
    $83ff99eb528b29b5$var$interceptors.push(callback);
}
function $83ff99eb528b29b5$var$cloneNode(from, to) {
    $83ff99eb528b29b5$var$interceptors.forEach((i)=>i(from, to));
    $83ff99eb528b29b5$var$isCloning = true;
    $83ff99eb528b29b5$var$dontRegisterReactiveSideEffects(()=>{
        $83ff99eb528b29b5$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $83ff99eb528b29b5$var$isCloning = false;
}
var $83ff99eb528b29b5$var$isCloningLegacy = false;
function $83ff99eb528b29b5$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $83ff99eb528b29b5$var$isCloning = true;
    $83ff99eb528b29b5$var$isCloningLegacy = true;
    $83ff99eb528b29b5$var$dontRegisterReactiveSideEffects(()=>{
        $83ff99eb528b29b5$var$cloneTree(newEl);
    });
    $83ff99eb528b29b5$var$isCloning = false;
    $83ff99eb528b29b5$var$isCloningLegacy = false;
}
function $83ff99eb528b29b5$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $83ff99eb528b29b5$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $83ff99eb528b29b5$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $83ff99eb528b29b5$var$initTree(el, shallowWalker);
}
function $83ff99eb528b29b5$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $83ff99eb528b29b5$var$effect;
    $83ff99eb528b29b5$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $83ff99eb528b29b5$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $83ff99eb528b29b5$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $83ff99eb528b29b5$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $83ff99eb528b29b5$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $83ff99eb528b29b5$var$camelCase(name) : name;
    switch(name){
        case "value":
            $83ff99eb528b29b5$var$bindInputValue(el, value);
            break;
        case "style":
            $83ff99eb528b29b5$var$bindStyles(el, value);
            break;
        case "class":
            $83ff99eb528b29b5$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $83ff99eb528b29b5$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $83ff99eb528b29b5$var$bindAttribute(el, name, value);
            break;
    }
}
function $83ff99eb528b29b5$var$bindInputValue(el, value) {
    if ($83ff99eb528b29b5$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $83ff99eb528b29b5$var$safeParseBoolean(el.value) === value;
            else el.checked = $83ff99eb528b29b5$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($83ff99eb528b29b5$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$83ff99eb528b29b5$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $83ff99eb528b29b5$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $83ff99eb528b29b5$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $83ff99eb528b29b5$var$setClasses(el, value);
}
function $83ff99eb528b29b5$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $83ff99eb528b29b5$var$setStyles(el, value);
}
function $83ff99eb528b29b5$var$bindAttributeAndProperty(el, name, value) {
    $83ff99eb528b29b5$var$bindAttribute(el, name, value);
    $83ff99eb528b29b5$var$setPropertyIfChanged(el, name, value);
}
function $83ff99eb528b29b5$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $83ff99eb528b29b5$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($83ff99eb528b29b5$var$isBooleanAttr(name)) value = name;
        $83ff99eb528b29b5$var$setIfChanged(el, name, value);
    }
}
function $83ff99eb528b29b5$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $83ff99eb528b29b5$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $83ff99eb528b29b5$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $83ff99eb528b29b5$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $83ff99eb528b29b5$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $83ff99eb528b29b5$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $83ff99eb528b29b5$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $83ff99eb528b29b5$var$isBooleanAttr(attrName) {
    return $83ff99eb528b29b5$var$booleanAttributes.has(attrName);
}
function $83ff99eb528b29b5$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $83ff99eb528b29b5$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $83ff99eb528b29b5$var$getAttributeBinding(el, name, fallback);
}
function $83ff99eb528b29b5$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $83ff99eb528b29b5$var$dontAutoEvaluateFunctions(()=>{
            return $83ff99eb528b29b5$var$evaluate(el, binding.expression);
        });
    }
    return $83ff99eb528b29b5$var$getAttributeBinding(el, name, fallback);
}
function $83ff99eb528b29b5$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($83ff99eb528b29b5$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $83ff99eb528b29b5$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $83ff99eb528b29b5$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $83ff99eb528b29b5$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $83ff99eb528b29b5$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $83ff99eb528b29b5$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $83ff99eb528b29b5$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($83ff99eb528b29b5$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($83ff99eb528b29b5$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($83ff99eb528b29b5$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $83ff99eb528b29b5$var$release(reference);
    };
}
function $83ff99eb528b29b5$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $83ff99eb528b29b5$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($83ff99eb528b29b5$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $83ff99eb528b29b5$var$stores = {};
var $83ff99eb528b29b5$var$isReactive = false;
function $83ff99eb528b29b5$var$store(name, value) {
    if (!$83ff99eb528b29b5$var$isReactive) {
        $83ff99eb528b29b5$var$stores = $83ff99eb528b29b5$var$reactive($83ff99eb528b29b5$var$stores);
        $83ff99eb528b29b5$var$isReactive = true;
    }
    if (value === void 0) return $83ff99eb528b29b5$var$stores[name];
    $83ff99eb528b29b5$var$stores[name] = value;
    $83ff99eb528b29b5$var$initInterceptors($83ff99eb528b29b5$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $83ff99eb528b29b5$var$stores[name].init();
}
function $83ff99eb528b29b5$var$getStores() {
    return $83ff99eb528b29b5$var$stores;
}
// packages/alpinejs/src/binds.js
var $83ff99eb528b29b5$var$binds = {};
function $83ff99eb528b29b5$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $83ff99eb528b29b5$var$applyBindingsObject(name, getBindings());
    else $83ff99eb528b29b5$var$binds[name] = getBindings;
    return ()=>{};
}
function $83ff99eb528b29b5$var$injectBindingProviders(obj) {
    Object.entries($83ff99eb528b29b5$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $83ff99eb528b29b5$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $83ff99eb528b29b5$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $83ff99eb528b29b5$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $83ff99eb528b29b5$var$datas = {};
function $83ff99eb528b29b5$var$data(name, callback) {
    $83ff99eb528b29b5$var$datas[name] = callback;
}
function $83ff99eb528b29b5$var$injectDataProviders(obj, context) {
    Object.entries($83ff99eb528b29b5$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $83ff99eb528b29b5$var$Alpine = {
    get reactive () {
        return $83ff99eb528b29b5$var$reactive;
    },
    get release () {
        return $83ff99eb528b29b5$var$release;
    },
    get effect () {
        return $83ff99eb528b29b5$var$effect;
    },
    get raw () {
        return $83ff99eb528b29b5$var$raw;
    },
    version: "3.14.9",
    flushAndStopDeferringMutations: $83ff99eb528b29b5$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $83ff99eb528b29b5$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $83ff99eb528b29b5$var$disableEffectScheduling,
    startObservingMutations: $83ff99eb528b29b5$var$startObservingMutations,
    stopObservingMutations: $83ff99eb528b29b5$var$stopObservingMutations,
    setReactivityEngine: $83ff99eb528b29b5$var$setReactivityEngine,
    onAttributeRemoved: $83ff99eb528b29b5$var$onAttributeRemoved,
    onAttributesAdded: $83ff99eb528b29b5$var$onAttributesAdded,
    closestDataStack: $83ff99eb528b29b5$var$closestDataStack,
    skipDuringClone: $83ff99eb528b29b5$var$skipDuringClone,
    onlyDuringClone: $83ff99eb528b29b5$var$onlyDuringClone,
    addRootSelector: $83ff99eb528b29b5$var$addRootSelector,
    addInitSelector: $83ff99eb528b29b5$var$addInitSelector,
    interceptClone: $83ff99eb528b29b5$var$interceptClone,
    addScopeToNode: $83ff99eb528b29b5$var$addScopeToNode,
    deferMutations: $83ff99eb528b29b5$var$deferMutations,
    mapAttributes: $83ff99eb528b29b5$var$mapAttributes,
    evaluateLater: $83ff99eb528b29b5$var$evaluateLater,
    interceptInit: $83ff99eb528b29b5$var$interceptInit,
    setEvaluator: $83ff99eb528b29b5$var$setEvaluator,
    mergeProxies: $83ff99eb528b29b5$var$mergeProxies,
    extractProp: $83ff99eb528b29b5$var$extractProp,
    findClosest: $83ff99eb528b29b5$var$findClosest,
    onElRemoved: $83ff99eb528b29b5$var$onElRemoved,
    closestRoot: $83ff99eb528b29b5$var$closestRoot,
    destroyTree: $83ff99eb528b29b5$var$destroyTree,
    interceptor: $83ff99eb528b29b5$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $83ff99eb528b29b5$var$transition,
    setStyles: // INTERNAL
    $83ff99eb528b29b5$var$setStyles,
    mutateDom: // INTERNAL
    $83ff99eb528b29b5$var$mutateDom,
    directive: $83ff99eb528b29b5$var$directive,
    entangle: $83ff99eb528b29b5$var$entangle,
    throttle: $83ff99eb528b29b5$var$throttle,
    debounce: $83ff99eb528b29b5$var$debounce,
    evaluate: $83ff99eb528b29b5$var$evaluate,
    initTree: $83ff99eb528b29b5$var$initTree,
    nextTick: $83ff99eb528b29b5$var$nextTick,
    prefixed: $83ff99eb528b29b5$var$prefix,
    prefix: $83ff99eb528b29b5$var$setPrefix,
    plugin: $83ff99eb528b29b5$var$plugin,
    magic: $83ff99eb528b29b5$var$magic,
    store: $83ff99eb528b29b5$var$store,
    start: $83ff99eb528b29b5$var$start,
    clone: $83ff99eb528b29b5$var$clone,
    cloneNode: // INTERNAL
    $83ff99eb528b29b5$var$cloneNode,
    // INTERNAL
    bound: $83ff99eb528b29b5$var$getBinding,
    $data: $83ff99eb528b29b5$var$scope,
    watch: $83ff99eb528b29b5$var$watch,
    walk: $83ff99eb528b29b5$var$walk,
    data: $83ff99eb528b29b5$var$data,
    bind: $83ff99eb528b29b5$var$bind2
};
var $83ff99eb528b29b5$var$alpine_default = $83ff99eb528b29b5$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $83ff99eb528b29b5$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $83ff99eb528b29b5$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $83ff99eb528b29b5$var$isBooleanAttr2 = /* @__PURE__ */ $83ff99eb528b29b5$var$makeMap($83ff99eb528b29b5$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $83ff99eb528b29b5$var$EMPTY_OBJ = Object.freeze({});
var $83ff99eb528b29b5$var$EMPTY_ARR = Object.freeze([]);
var $83ff99eb528b29b5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $83ff99eb528b29b5$var$hasOwn = (val, key)=>$83ff99eb528b29b5$var$hasOwnProperty.call(val, key);
var $83ff99eb528b29b5$var$isArray = Array.isArray;
var $83ff99eb528b29b5$var$isMap = (val)=>$83ff99eb528b29b5$var$toTypeString(val) === "[object Map]";
var $83ff99eb528b29b5$var$isString = (val)=>typeof val === "string";
var $83ff99eb528b29b5$var$isSymbol = (val)=>typeof val === "symbol";
var $83ff99eb528b29b5$var$isObject = (val)=>val !== null && typeof val === "object";
var $83ff99eb528b29b5$var$objectToString = Object.prototype.toString;
var $83ff99eb528b29b5$var$toTypeString = (value)=>$83ff99eb528b29b5$var$objectToString.call(value);
var $83ff99eb528b29b5$var$toRawType = (value)=>{
    return $83ff99eb528b29b5$var$toTypeString(value).slice(8, -1);
};
var $83ff99eb528b29b5$var$isIntegerKey = (key)=>$83ff99eb528b29b5$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $83ff99eb528b29b5$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $83ff99eb528b29b5$var$camelizeRE = /-(\w)/g;
var $83ff99eb528b29b5$var$camelize = $83ff99eb528b29b5$var$cacheStringFunction((str)=>{
    return str.replace($83ff99eb528b29b5$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $83ff99eb528b29b5$var$hyphenateRE = /\B([A-Z])/g;
var $83ff99eb528b29b5$var$hyphenate = $83ff99eb528b29b5$var$cacheStringFunction((str)=>str.replace($83ff99eb528b29b5$var$hyphenateRE, "-$1").toLowerCase());
var $83ff99eb528b29b5$var$capitalize = $83ff99eb528b29b5$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $83ff99eb528b29b5$var$toHandlerKey = $83ff99eb528b29b5$var$cacheStringFunction((str)=>str ? `on${$83ff99eb528b29b5$var$capitalize(str)}` : ``);
var $83ff99eb528b29b5$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $83ff99eb528b29b5$var$targetMap = /* @__PURE__ */ new WeakMap();
var $83ff99eb528b29b5$var$effectStack = [];
var $83ff99eb528b29b5$var$activeEffect;
var $83ff99eb528b29b5$var$ITERATE_KEY = Symbol("iterate");
var $83ff99eb528b29b5$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $83ff99eb528b29b5$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $83ff99eb528b29b5$var$effect2(fn, options = $83ff99eb528b29b5$var$EMPTY_OBJ) {
    if ($83ff99eb528b29b5$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $83ff99eb528b29b5$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $83ff99eb528b29b5$var$stop(effect3) {
    if (effect3.active) {
        $83ff99eb528b29b5$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $83ff99eb528b29b5$var$uid = 0;
function $83ff99eb528b29b5$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$83ff99eb528b29b5$var$effectStack.includes(effect3)) {
            $83ff99eb528b29b5$var$cleanup(effect3);
            try {
                $83ff99eb528b29b5$var$enableTracking();
                $83ff99eb528b29b5$var$effectStack.push(effect3);
                $83ff99eb528b29b5$var$activeEffect = effect3;
                return fn();
            } finally{
                $83ff99eb528b29b5$var$effectStack.pop();
                $83ff99eb528b29b5$var$resetTracking();
                $83ff99eb528b29b5$var$activeEffect = $83ff99eb528b29b5$var$effectStack[$83ff99eb528b29b5$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $83ff99eb528b29b5$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $83ff99eb528b29b5$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $83ff99eb528b29b5$var$shouldTrack = true;
var $83ff99eb528b29b5$var$trackStack = [];
function $83ff99eb528b29b5$var$pauseTracking() {
    $83ff99eb528b29b5$var$trackStack.push($83ff99eb528b29b5$var$shouldTrack);
    $83ff99eb528b29b5$var$shouldTrack = false;
}
function $83ff99eb528b29b5$var$enableTracking() {
    $83ff99eb528b29b5$var$trackStack.push($83ff99eb528b29b5$var$shouldTrack);
    $83ff99eb528b29b5$var$shouldTrack = true;
}
function $83ff99eb528b29b5$var$resetTracking() {
    const last = $83ff99eb528b29b5$var$trackStack.pop();
    $83ff99eb528b29b5$var$shouldTrack = last === void 0 ? true : last;
}
function $83ff99eb528b29b5$var$track(target, type, key) {
    if (!$83ff99eb528b29b5$var$shouldTrack || $83ff99eb528b29b5$var$activeEffect === void 0) return;
    let depsMap = $83ff99eb528b29b5$var$targetMap.get(target);
    if (!depsMap) $83ff99eb528b29b5$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($83ff99eb528b29b5$var$activeEffect)) {
        dep.add($83ff99eb528b29b5$var$activeEffect);
        $83ff99eb528b29b5$var$activeEffect.deps.push(dep);
        if ($83ff99eb528b29b5$var$activeEffect.options.onTrack) $83ff99eb528b29b5$var$activeEffect.options.onTrack({
            effect: $83ff99eb528b29b5$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $83ff99eb528b29b5$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $83ff99eb528b29b5$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $83ff99eb528b29b5$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $83ff99eb528b29b5$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$83ff99eb528b29b5$var$isArray(target)) {
                    add2(depsMap.get($83ff99eb528b29b5$var$ITERATE_KEY));
                    if ($83ff99eb528b29b5$var$isMap(target)) add2(depsMap.get($83ff99eb528b29b5$var$MAP_KEY_ITERATE_KEY));
                } else if ($83ff99eb528b29b5$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$83ff99eb528b29b5$var$isArray(target)) {
                    add2(depsMap.get($83ff99eb528b29b5$var$ITERATE_KEY));
                    if ($83ff99eb528b29b5$var$isMap(target)) add2(depsMap.get($83ff99eb528b29b5$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($83ff99eb528b29b5$var$isMap(target)) add2(depsMap.get($83ff99eb528b29b5$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $83ff99eb528b29b5$var$isNonTrackableKeys = /* @__PURE__ */ $83ff99eb528b29b5$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $83ff99eb528b29b5$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($83ff99eb528b29b5$var$isSymbol));
var $83ff99eb528b29b5$var$get2 = /* @__PURE__ */ $83ff99eb528b29b5$var$createGetter();
var $83ff99eb528b29b5$var$readonlyGet = /* @__PURE__ */ $83ff99eb528b29b5$var$createGetter(true);
var $83ff99eb528b29b5$var$arrayInstrumentations = /* @__PURE__ */ $83ff99eb528b29b5$var$createArrayInstrumentations();
function $83ff99eb528b29b5$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $83ff99eb528b29b5$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$83ff99eb528b29b5$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($83ff99eb528b29b5$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $83ff99eb528b29b5$var$pauseTracking();
            const res = $83ff99eb528b29b5$var$toRaw(this)[key].apply(this, args);
            $83ff99eb528b29b5$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $83ff99eb528b29b5$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $83ff99eb528b29b5$var$shallowReadonlyMap : $83ff99eb528b29b5$var$readonlyMap : shallow ? $83ff99eb528b29b5$var$shallowReactiveMap : $83ff99eb528b29b5$var$reactiveMap).get(target)) return target;
        const targetIsArray = $83ff99eb528b29b5$var$isArray(target);
        if (!isReadonly && targetIsArray && $83ff99eb528b29b5$var$hasOwn($83ff99eb528b29b5$var$arrayInstrumentations, key)) return Reflect.get($83ff99eb528b29b5$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($83ff99eb528b29b5$var$isSymbol(key) ? $83ff99eb528b29b5$var$builtInSymbols.has(key) : $83ff99eb528b29b5$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $83ff99eb528b29b5$var$track(target, "get", key);
        if (shallow) return res;
        if ($83ff99eb528b29b5$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$83ff99eb528b29b5$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($83ff99eb528b29b5$var$isObject(res)) return isReadonly ? $83ff99eb528b29b5$var$readonly(res) : $83ff99eb528b29b5$var$reactive2(res);
        return res;
    };
}
var $83ff99eb528b29b5$var$set2 = /* @__PURE__ */ $83ff99eb528b29b5$var$createSetter();
function $83ff99eb528b29b5$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $83ff99eb528b29b5$var$toRaw(value);
            oldValue = $83ff99eb528b29b5$var$toRaw(oldValue);
            if (!$83ff99eb528b29b5$var$isArray(target) && $83ff99eb528b29b5$var$isRef(oldValue) && !$83ff99eb528b29b5$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $83ff99eb528b29b5$var$isArray(target) && $83ff99eb528b29b5$var$isIntegerKey(key) ? Number(key) < target.length : $83ff99eb528b29b5$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $83ff99eb528b29b5$var$toRaw(receiver)) {
            if (!hadKey) $83ff99eb528b29b5$var$trigger(target, "add", key, value);
            else if ($83ff99eb528b29b5$var$hasChanged(value, oldValue)) $83ff99eb528b29b5$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $83ff99eb528b29b5$var$deleteProperty(target, key) {
    const hadKey = $83ff99eb528b29b5$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $83ff99eb528b29b5$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $83ff99eb528b29b5$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$83ff99eb528b29b5$var$isSymbol(key) || !$83ff99eb528b29b5$var$builtInSymbols.has(key)) $83ff99eb528b29b5$var$track(target, "has", key);
    return result;
}
function $83ff99eb528b29b5$var$ownKeys(target) {
    $83ff99eb528b29b5$var$track(target, "iterate", $83ff99eb528b29b5$var$isArray(target) ? "length" : $83ff99eb528b29b5$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $83ff99eb528b29b5$var$mutableHandlers = {
    get: $83ff99eb528b29b5$var$get2,
    set: $83ff99eb528b29b5$var$set2,
    deleteProperty: $83ff99eb528b29b5$var$deleteProperty,
    has: $83ff99eb528b29b5$var$has,
    ownKeys: $83ff99eb528b29b5$var$ownKeys
};
var $83ff99eb528b29b5$var$readonlyHandlers = {
    get: $83ff99eb528b29b5$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $83ff99eb528b29b5$var$toReactive = (value)=>$83ff99eb528b29b5$var$isObject(value) ? $83ff99eb528b29b5$var$reactive2(value) : value;
var $83ff99eb528b29b5$var$toReadonly = (value)=>$83ff99eb528b29b5$var$isObject(value) ? $83ff99eb528b29b5$var$readonly(value) : value;
var $83ff99eb528b29b5$var$toShallow = (value)=>value;
var $83ff99eb528b29b5$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $83ff99eb528b29b5$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $83ff99eb528b29b5$var$toRaw(target);
    const rawKey = $83ff99eb528b29b5$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $83ff99eb528b29b5$var$track(rawTarget, "get", key);
    !isReadonly && $83ff99eb528b29b5$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $83ff99eb528b29b5$var$getProto(rawTarget);
    const wrap = isShallow ? $83ff99eb528b29b5$var$toShallow : isReadonly ? $83ff99eb528b29b5$var$toReadonly : $83ff99eb528b29b5$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $83ff99eb528b29b5$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $83ff99eb528b29b5$var$toRaw(target);
    const rawKey = $83ff99eb528b29b5$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $83ff99eb528b29b5$var$track(rawTarget, "has", key);
    !isReadonly && $83ff99eb528b29b5$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $83ff99eb528b29b5$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $83ff99eb528b29b5$var$track($83ff99eb528b29b5$var$toRaw(target), "iterate", $83ff99eb528b29b5$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $83ff99eb528b29b5$var$add(value) {
    value = $83ff99eb528b29b5$var$toRaw(value);
    const target = $83ff99eb528b29b5$var$toRaw(this);
    const proto = $83ff99eb528b29b5$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $83ff99eb528b29b5$var$trigger(target, "add", value, value);
    }
    return this;
}
function $83ff99eb528b29b5$var$set$1(key, value) {
    value = $83ff99eb528b29b5$var$toRaw(value);
    const target = $83ff99eb528b29b5$var$toRaw(this);
    const { has: has2, get: get3 } = $83ff99eb528b29b5$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $83ff99eb528b29b5$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $83ff99eb528b29b5$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $83ff99eb528b29b5$var$trigger(target, "add", key, value);
    else if ($83ff99eb528b29b5$var$hasChanged(value, oldValue)) $83ff99eb528b29b5$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $83ff99eb528b29b5$var$deleteEntry(key) {
    const target = $83ff99eb528b29b5$var$toRaw(this);
    const { has: has2, get: get3 } = $83ff99eb528b29b5$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $83ff99eb528b29b5$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $83ff99eb528b29b5$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $83ff99eb528b29b5$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $83ff99eb528b29b5$var$clear() {
    const target = $83ff99eb528b29b5$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $83ff99eb528b29b5$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $83ff99eb528b29b5$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $83ff99eb528b29b5$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $83ff99eb528b29b5$var$toRaw(target);
        const wrap = isShallow ? $83ff99eb528b29b5$var$toShallow : isReadonly ? $83ff99eb528b29b5$var$toReadonly : $83ff99eb528b29b5$var$toReactive;
        !isReadonly && $83ff99eb528b29b5$var$track(rawTarget, "iterate", $83ff99eb528b29b5$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $83ff99eb528b29b5$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $83ff99eb528b29b5$var$toRaw(target);
        const targetIsMap = $83ff99eb528b29b5$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $83ff99eb528b29b5$var$toShallow : isReadonly ? $83ff99eb528b29b5$var$toReadonly : $83ff99eb528b29b5$var$toReactive;
        !isReadonly && $83ff99eb528b29b5$var$track(rawTarget, "iterate", isKeyOnly ? $83ff99eb528b29b5$var$MAP_KEY_ITERATE_KEY : $83ff99eb528b29b5$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $83ff99eb528b29b5$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$83ff99eb528b29b5$var$capitalize(type)} operation ${key}failed: target is readonly.`, $83ff99eb528b29b5$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $83ff99eb528b29b5$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $83ff99eb528b29b5$var$get$1(this, key);
        },
        get size () {
            return $83ff99eb528b29b5$var$size(this);
        },
        has: $83ff99eb528b29b5$var$has$1,
        add: $83ff99eb528b29b5$var$add,
        set: $83ff99eb528b29b5$var$set$1,
        delete: $83ff99eb528b29b5$var$deleteEntry,
        clear: $83ff99eb528b29b5$var$clear,
        forEach: $83ff99eb528b29b5$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $83ff99eb528b29b5$var$get$1(this, key, false, true);
        },
        get size () {
            return $83ff99eb528b29b5$var$size(this);
        },
        has: $83ff99eb528b29b5$var$has$1,
        add: $83ff99eb528b29b5$var$add,
        set: $83ff99eb528b29b5$var$set$1,
        delete: $83ff99eb528b29b5$var$deleteEntry,
        clear: $83ff99eb528b29b5$var$clear,
        forEach: $83ff99eb528b29b5$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $83ff99eb528b29b5$var$get$1(this, key, true);
        },
        get size () {
            return $83ff99eb528b29b5$var$size(this, true);
        },
        has (key) {
            return $83ff99eb528b29b5$var$has$1.call(this, key, true);
        },
        add: $83ff99eb528b29b5$var$createReadonlyMethod("add"),
        set: $83ff99eb528b29b5$var$createReadonlyMethod("set"),
        delete: $83ff99eb528b29b5$var$createReadonlyMethod("delete"),
        clear: $83ff99eb528b29b5$var$createReadonlyMethod("clear"),
        forEach: $83ff99eb528b29b5$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $83ff99eb528b29b5$var$get$1(this, key, true, true);
        },
        get size () {
            return $83ff99eb528b29b5$var$size(this, true);
        },
        has (key) {
            return $83ff99eb528b29b5$var$has$1.call(this, key, true);
        },
        add: $83ff99eb528b29b5$var$createReadonlyMethod("add"),
        set: $83ff99eb528b29b5$var$createReadonlyMethod("set"),
        delete: $83ff99eb528b29b5$var$createReadonlyMethod("delete"),
        clear: $83ff99eb528b29b5$var$createReadonlyMethod("clear"),
        forEach: $83ff99eb528b29b5$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $83ff99eb528b29b5$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $83ff99eb528b29b5$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $83ff99eb528b29b5$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $83ff99eb528b29b5$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$83ff99eb528b29b5$var$mutableInstrumentations, $83ff99eb528b29b5$var$readonlyInstrumentations, $83ff99eb528b29b5$var$shallowInstrumentations, $83ff99eb528b29b5$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $83ff99eb528b29b5$var$createInstrumentations();
function $83ff99eb528b29b5$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $83ff99eb528b29b5$var$shallowReadonlyInstrumentations : $83ff99eb528b29b5$var$shallowInstrumentations : isReadonly ? $83ff99eb528b29b5$var$readonlyInstrumentations : $83ff99eb528b29b5$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($83ff99eb528b29b5$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $83ff99eb528b29b5$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $83ff99eb528b29b5$var$createInstrumentationGetter(false, false)
};
var $83ff99eb528b29b5$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $83ff99eb528b29b5$var$createInstrumentationGetter(true, false)
};
function $83ff99eb528b29b5$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $83ff99eb528b29b5$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $83ff99eb528b29b5$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $83ff99eb528b29b5$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $83ff99eb528b29b5$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $83ff99eb528b29b5$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $83ff99eb528b29b5$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $83ff99eb528b29b5$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $83ff99eb528b29b5$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $83ff99eb528b29b5$var$targetTypeMap($83ff99eb528b29b5$var$toRawType(value));
}
function $83ff99eb528b29b5$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $83ff99eb528b29b5$var$createReactiveObject(target, false, $83ff99eb528b29b5$var$mutableHandlers, $83ff99eb528b29b5$var$mutableCollectionHandlers, $83ff99eb528b29b5$var$reactiveMap);
}
function $83ff99eb528b29b5$var$readonly(target) {
    return $83ff99eb528b29b5$var$createReactiveObject(target, true, $83ff99eb528b29b5$var$readonlyHandlers, $83ff99eb528b29b5$var$readonlyCollectionHandlers, $83ff99eb528b29b5$var$readonlyMap);
}
function $83ff99eb528b29b5$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$83ff99eb528b29b5$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $83ff99eb528b29b5$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $83ff99eb528b29b5$var$toRaw(observed) {
    return observed && $83ff99eb528b29b5$var$toRaw(observed["__v_raw"]) || observed;
}
function $83ff99eb528b29b5$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$83ff99eb528b29b5$var$magic("nextTick", ()=>$83ff99eb528b29b5$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$83ff99eb528b29b5$var$magic("dispatch", (el)=>$83ff99eb528b29b5$var$dispatch.bind($83ff99eb528b29b5$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$83ff99eb528b29b5$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $83ff99eb528b29b5$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$83ff99eb528b29b5$var$magic("store", $83ff99eb528b29b5$var$getStores);
// packages/alpinejs/src/magics/$data.js
$83ff99eb528b29b5$var$magic("data", (el)=>$83ff99eb528b29b5$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$83ff99eb528b29b5$var$magic("root", (el)=>$83ff99eb528b29b5$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$83ff99eb528b29b5$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $83ff99eb528b29b5$var$mergeProxies($83ff99eb528b29b5$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $83ff99eb528b29b5$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $83ff99eb528b29b5$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $83ff99eb528b29b5$var$globalIdMemo = {};
function $83ff99eb528b29b5$var$findAndIncrementId(name) {
    if (!$83ff99eb528b29b5$var$globalIdMemo[name]) $83ff99eb528b29b5$var$globalIdMemo[name] = 0;
    return ++$83ff99eb528b29b5$var$globalIdMemo[name];
}
function $83ff99eb528b29b5$var$closestIdRoot(el, name) {
    return $83ff99eb528b29b5$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $83ff99eb528b29b5$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $83ff99eb528b29b5$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$83ff99eb528b29b5$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $83ff99eb528b29b5$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $83ff99eb528b29b5$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $83ff99eb528b29b5$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$83ff99eb528b29b5$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $83ff99eb528b29b5$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$83ff99eb528b29b5$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$83ff99eb528b29b5$var$warnMissingPluginMagic("Focus", "focus", "focus");
$83ff99eb528b29b5$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $83ff99eb528b29b5$var$warnMissingPluginMagic(name, magicName, slug) {
    $83ff99eb528b29b5$var$magic(magicName, (el)=>$83ff99eb528b29b5$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$83ff99eb528b29b5$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $83ff99eb528b29b5$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$83ff99eb528b29b5$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $83ff99eb528b29b5$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $83ff99eb528b29b5$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $83ff99eb528b29b5$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $83ff99eb528b29b5$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $83ff99eb528b29b5$var$skipDuringClone(()=>{
            $83ff99eb528b29b5$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $83ff99eb528b29b5$var$getTarget(expression);
        $83ff99eb528b29b5$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$83ff99eb528b29b5$var$mutateDom(()=>{
            clone2.remove();
            $83ff99eb528b29b5$var$destroyTree(clone2);
        }));
});
var $83ff99eb528b29b5$var$teleportContainerDuringClone = document.createElement("div");
function $83ff99eb528b29b5$var$getTarget(expression) {
    let target = $83ff99eb528b29b5$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $83ff99eb528b29b5$var$teleportContainerDuringClone;
    })();
    if (!target) $83ff99eb528b29b5$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $83ff99eb528b29b5$var$handler = ()=>{};
$83ff99eb528b29b5$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$83ff99eb528b29b5$var$directive("ignore", $83ff99eb528b29b5$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$83ff99eb528b29b5$var$directive("effect", $83ff99eb528b29b5$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($83ff99eb528b29b5$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $83ff99eb528b29b5$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $83ff99eb528b29b5$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $83ff99eb528b29b5$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $83ff99eb528b29b5$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $83ff99eb528b29b5$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $83ff99eb528b29b5$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $83ff99eb528b29b5$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($83ff99eb528b29b5$var$isKeyEvent(event) || $83ff99eb528b29b5$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($83ff99eb528b29b5$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $83ff99eb528b29b5$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $83ff99eb528b29b5$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $83ff99eb528b29b5$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $83ff99eb528b29b5$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $83ff99eb528b29b5$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $83ff99eb528b29b5$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $83ff99eb528b29b5$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $83ff99eb528b29b5$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $83ff99eb528b29b5$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $83ff99eb528b29b5$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($83ff99eb528b29b5$var$isClickEvent(e.type)) return false;
            if ($83ff99eb528b29b5$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $83ff99eb528b29b5$var$keyToModifiers(key) {
    if (!key) return [];
    key = $83ff99eb528b29b5$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$83ff99eb528b29b5$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $83ff99eb528b29b5$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $83ff99eb528b29b5$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $83ff99eb528b29b5$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $83ff99eb528b29b5$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($83ff99eb528b29b5$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $83ff99eb528b29b5$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $83ff99eb528b29b5$var$isCloning ? ()=>{} : $83ff99eb528b29b5$var$on(el, event, modifiers, (e)=>{
        setValue($83ff99eb528b29b5$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $83ff99eb528b29b5$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($83ff99eb528b29b5$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $83ff99eb528b29b5$var$on(el.form, "reset", [], (e)=>{
            $83ff99eb528b29b5$var$nextTick(()=>el._x_model && el._x_model.set($83ff99eb528b29b5$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $83ff99eb528b29b5$var$mutateDom(()=>$83ff99eb528b29b5$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $83ff99eb528b29b5$var$getInputValue(el, modifiers, event, currentValue) {
    return $83ff99eb528b29b5$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($83ff99eb528b29b5$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $83ff99eb528b29b5$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $83ff99eb528b29b5$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$83ff99eb528b29b5$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $83ff99eb528b29b5$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $83ff99eb528b29b5$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($83ff99eb528b29b5$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $83ff99eb528b29b5$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $83ff99eb528b29b5$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $83ff99eb528b29b5$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $83ff99eb528b29b5$var$isNumeric2(number) ? number : rawValue;
}
function $83ff99eb528b29b5$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $83ff99eb528b29b5$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $83ff99eb528b29b5$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$83ff99eb528b29b5$var$directive("cloak", (el)=>queueMicrotask(()=>$83ff99eb528b29b5$var$mutateDom(()=>el.removeAttribute($83ff99eb528b29b5$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$83ff99eb528b29b5$var$addInitSelector(()=>`[${$83ff99eb528b29b5$var$prefix("init")}]`);
$83ff99eb528b29b5$var$directive("init", $83ff99eb528b29b5$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$83ff99eb528b29b5$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $83ff99eb528b29b5$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$83ff99eb528b29b5$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $83ff99eb528b29b5$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $83ff99eb528b29b5$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$83ff99eb528b29b5$var$mapAttributes($83ff99eb528b29b5$var$startingWith(":", $83ff99eb528b29b5$var$into($83ff99eb528b29b5$var$prefix("bind:"))));
var $83ff99eb528b29b5$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $83ff99eb528b29b5$var$injectBindingProviders(bindingProviders);
        let getBindings = $83ff99eb528b29b5$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $83ff99eb528b29b5$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $83ff99eb528b29b5$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $83ff99eb528b29b5$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $83ff99eb528b29b5$var$mutateDom(()=>$83ff99eb528b29b5$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$83ff99eb528b29b5$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$83ff99eb528b29b5$var$directive("bind", $83ff99eb528b29b5$var$handler2);
function $83ff99eb528b29b5$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$83ff99eb528b29b5$var$addRootSelector(()=>`[${$83ff99eb528b29b5$var$prefix("data")}]`);
$83ff99eb528b29b5$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($83ff99eb528b29b5$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $83ff99eb528b29b5$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $83ff99eb528b29b5$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $83ff99eb528b29b5$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $83ff99eb528b29b5$var$injectMagics(data2, el);
    let reactiveData = $83ff99eb528b29b5$var$reactive(data2);
    $83ff99eb528b29b5$var$initInterceptors(reactiveData);
    let undo = $83ff99eb528b29b5$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $83ff99eb528b29b5$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $83ff99eb528b29b5$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$83ff99eb528b29b5$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $83ff99eb528b29b5$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$83ff99eb528b29b5$var$isCloning) return false;
    if ($83ff99eb528b29b5$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$83ff99eb528b29b5$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $83ff99eb528b29b5$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $83ff99eb528b29b5$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $83ff99eb528b29b5$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $83ff99eb528b29b5$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$83ff99eb528b29b5$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $83ff99eb528b29b5$var$parseForExpression(expression);
    let evaluateItems = $83ff99eb528b29b5$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $83ff99eb528b29b5$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$83ff99eb528b29b5$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$83ff99eb528b29b5$var$mutateDom(()=>{
                $83ff99eb528b29b5$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $83ff99eb528b29b5$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($83ff99eb528b29b5$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $83ff99eb528b29b5$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $83ff99eb528b29b5$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $83ff99eb528b29b5$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $83ff99eb528b29b5$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $83ff99eb528b29b5$var$mutateDom(()=>{
                $83ff99eb528b29b5$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $83ff99eb528b29b5$var$mutateDom(()=>{
                if (!elForSpot) $83ff99eb528b29b5$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $83ff99eb528b29b5$var$reactive(scope2);
            $83ff99eb528b29b5$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $83ff99eb528b29b5$var$mutateDom(()=>{
                lastEl.after(clone2);
                $83ff99eb528b29b5$var$skipDuringClone(()=>$83ff99eb528b29b5$var$initTree(clone2))();
            });
            if (typeof key === "object") $83ff99eb528b29b5$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $83ff99eb528b29b5$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $83ff99eb528b29b5$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $83ff99eb528b29b5$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $83ff99eb528b29b5$var$handler3() {}
$83ff99eb528b29b5$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $83ff99eb528b29b5$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$83ff99eb528b29b5$var$directive("ref", $83ff99eb528b29b5$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$83ff99eb528b29b5$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $83ff99eb528b29b5$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $83ff99eb528b29b5$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $83ff99eb528b29b5$var$addScopeToNode(clone2, {}, el);
        $83ff99eb528b29b5$var$mutateDom(()=>{
            el.after(clone2);
            $83ff99eb528b29b5$var$skipDuringClone(()=>$83ff99eb528b29b5$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $83ff99eb528b29b5$var$mutateDom(()=>{
                $83ff99eb528b29b5$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$83ff99eb528b29b5$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$83ff99eb528b29b5$var$setIdRoot(el, name));
});
$83ff99eb528b29b5$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$83ff99eb528b29b5$var$mapAttributes($83ff99eb528b29b5$var$startingWith("@", $83ff99eb528b29b5$var$into($83ff99eb528b29b5$var$prefix("on:"))));
$83ff99eb528b29b5$var$directive("on", $83ff99eb528b29b5$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $83ff99eb528b29b5$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $83ff99eb528b29b5$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$83ff99eb528b29b5$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$83ff99eb528b29b5$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$83ff99eb528b29b5$var$warnMissingPluginDirective("Focus", "trap", "focus");
$83ff99eb528b29b5$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $83ff99eb528b29b5$var$warnMissingPluginDirective(name, directiveName, slug) {
    $83ff99eb528b29b5$var$directive(directiveName, (el)=>$83ff99eb528b29b5$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$83ff99eb528b29b5$var$alpine_default.setEvaluator($83ff99eb528b29b5$var$normalEvaluator);
$83ff99eb528b29b5$var$alpine_default.setReactivityEngine({
    reactive: $83ff99eb528b29b5$var$reactive2,
    effect: $83ff99eb528b29b5$var$effect2,
    release: $83ff99eb528b29b5$var$stop,
    raw: $83ff99eb528b29b5$var$toRaw
});
var $83ff99eb528b29b5$export$b7ee041e4ad2afec = $83ff99eb528b29b5$var$alpine_default;
// packages/alpinejs/builds/module.js
var $83ff99eb528b29b5$export$2e2bcd8739ae039 = $83ff99eb528b29b5$export$b7ee041e4ad2afec;


// packages/collapse/src/index.js
function $92611fbf6ebbb518$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $92611fbf6ebbb518$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $92611fbf6ebbb518$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $92611fbf6ebbb518$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $92611fbf6ebbb518$export$2e2bcd8739ae039 = $92611fbf6ebbb518$export$ec45920981e0ca9b;


(0, $83ff99eb528b29b5$export$2e2bcd8739ae039).plugin((0, $92611fbf6ebbb518$export$2e2bcd8739ae039));
window.Alpine = (0, $83ff99eb528b29b5$export$2e2bcd8739ae039);
const $bc4f20284337a43e$var$API_ENDPOINT = ""; //"http://127.0.0.1:3000";
const $bc4f20284337a43e$var$EMAIL_PATTERN = /(^|[\s(\uFF08])([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})(?=$|[\s),.!?;:\uFF09\uFF0C\u3002\uFF1B\uFF1A])/gi;
function $bc4f20284337a43e$var$escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, (char)=>{
        const htmlEscapes = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        };
        return htmlEscapes[char];
    });
}
function $bc4f20284337a43e$var$linkifyEmailAddresses(value) {
    return value.replace($bc4f20284337a43e$var$EMAIL_PATTERN, '$1<a href="mailto:$2" class="font-medium underline">$2</a>');
}
function $bc4f20284337a43e$var$formatMaintenanceMessage(value) {
    return $bc4f20284337a43e$var$linkifyEmailAddresses($bc4f20284337a43e$var$escapeHtml(value)).replace(/\r?\n/g, "<br />");
}
document.addEventListener("alpine:init", ()=>{
    //init
    //console.log("alpine init");
    // Maintenance notice - fetches from API
    (0, $83ff99eb528b29b5$export$2e2bcd8739ae039).data("maintenanceNotice", ()=>({
            visible: false,
            message: "",
            init () {
                fetch($bc4f20284337a43e$var$API_ENDPOINT + "/bcs_api/maintenance_message").then((res)=>res.json()).then((data)=>{
                    if (data.success && data.data && data.data.is_enabled) {
                        var lang = typeof emlang !== "undefined" ? emlang : "en";
                        var messageText = "";
                        if (lang === "tc") messageText = data.data.message_tc || data.data.message_en || "";
                        else if (lang === "sc") messageText = data.data.message_sc || data.data.message_en || "";
                        else messageText = data.data.message_en || "";
                        this.message = $bc4f20284337a43e$var$formatMaintenanceMessage(messageText);
                        // Build schedule info
                        var start = data.data.scheduled_start_at || "";
                        var end = data.data.scheduled_end_at || "";
                        if (start && end) {
                            var startStr = new Date(start + " UTC").toLocaleString();
                            var endStr = new Date(end + " UTC").toLocaleString();
                            this.message = this.message + " <strong>" + $bc4f20284337a43e$var$escapeHtml(startStr) + " \u2013 " + $bc4f20284337a43e$var$escapeHtml(endStr) + "</strong>";
                        }
                        if (this.message) this.visible = true;
                    }
                }).catch(()=>{});
            }
        }));
    //for file upload
    (0, $83ff99eb528b29b5$export$2e2bcd8739ae039).data("fileManager", ()=>({
            // waiting-input, uploading, done, success. fail
            status: "waiting-input",
            cardExpanded: null,
            file: null,
            filename: "",
            resultRegistrationNo: "",
            resultNameChinese: "",
            resultAddressEnglish: "",
            resultStartDate: "",
            files: [],
            filenames: [],
            filesTotal: 0,
            filesDone: 0,
            filesResultOrder: [],
            filesResultDict: {},
            filesResult: [],
            //Prevent the browser's default drag behavior, e.g. open file in browser
            onFileOver (e) {
                e.preventDefault();
            //console.log("onFileOver");
            },
            //main handle file upload
            onFileDrop (ev) {
                ev.preventDefault();
                this.files = [];
                if (ev.dataTransfer.items) {
                    if (ev.dataTransfer.items.length < 1) {
                        if (emlang && emlang === "en") {
                            alert("Not a file. Please select a file.");
                            return false;
                        }
                        alert("\u4E0D\u662F\u6A94\u6848,\u8ACB\u9078\u64C7\u4E00\u500B\u6A94\u6848");
                        return false;
                    }
                    let hasFile = false;
                    for(const key in ev.dataTransfer.items){
                        const fileItem = ev.dataTransfer.items[key];
                        if (fileItem.kind === "file") {
                            hasFile = true;
                            const file = fileItem.getAsFile();
                            this.files.push(file);
                        }
                    }
                    if (!hasFile) {
                        if (emlang && emlang === "en") {
                            alert("Not a file. Please select a file.");
                            return false;
                        }
                        alert("\u4E0D\u662F\u6A94\u6848,\u8ACB\u9078\u64C7\u4E00\u500B\u6A94\u6848");
                        return false;
                    }
                    console.log(this.files);
                    this.submitMultipleFile();
                } else {
                    // Use DataTransfer interface to access the file(s)
                    if (ev.dataTransfer.files.length < 1) {
                        if (emlang && emlang === "en") {
                            alert("Not a file. Please select a file.");
                            return false;
                        }
                        alert("\u4E0D\u662F\u6A94\u6848,\u8ACB\u9078\u64C7\u4E00\u500B\u6A94\u6848");
                        return false;
                    }
                    this.file = ev.dataTransfer.files[0];
                    this.files = ev.dataTransfer.files;
                    this.submitMultipleFile();
                }
            },
            onFileChange (event) {
                event.preventDefault();
                //console.log("onFileChange");
                if (event.target.files.length < 1) return false;
                this.file = event.target.files[0];
                this.files = event.target.files;
                this.submitMultipleFile();
            },
            submitMultipleFile () {
                this.filenames = [];
                this.status = "uploading";
                if (this.files.length < 0) {
                    this.status = "waiting-input";
                    return false;
                }
                if (this.files.length > 20) {
                    if (emlang && emlang === "en") alert("Please select up to 20 files.");
                    else if (emlang && emlang === "tc") alert("\u8ACB\u9078\u64C7\u6700\u591A20\u500B\u6A94\u6848");
                    else if (emlang && emlang === "sc") alert("\u8BF7\u6700\u591A\u9009\u62E920\u4E2A\u6587\u4EF6");
                    else alert("Too many files. Please select up to 5 files.");
                    this.status = "waiting-input";
                    return false;
                }
                this.filesTotal = this.files.length;
                this.filesDone = 0;
                for (const aFile of this.files){
                    this.filenames.push(aFile.name);
                    //readFile
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(aFile);
                    reader.onload = async (event)=>{
                        const fileContent = event.target.result;
                        let hex = await $bc4f20284337a43e$var$calcSha256(fileContent);
                        this.filesResultOrder[aFile.name] = hex;
                        //console.log(hex);
                        const options = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                hash: hex
                            })
                        };
                        //call api to validate the hash
                        fetch($bc4f20284337a43e$var$API_ENDPOINT + "/bcs_api/verify", options).then((response)=>response.json()).then((data)=>{
                            //console.log(data);
                            let fileRet = {};
                            if (data.success) {
                                //check in not cancel
                                fileRet.Filename = aFile.name;
                                fileRet.Status = "success";
                                fileRet.RegistrationNo = data.data.RegistrationNo || "";
                                fileRet.Name = data.data.NameChinese || "";
                                if (emlang && emlang === "en") fileRet.Name = data.data.NameEnglish || "";
                                fileRet.AddressEnglish = data.data.AddressEnglish || "";
                                fileRet.StartDate = data.data.StartDate || "";
                                fileRet.EndDate = data.data.EndDate || "";
                                fileRet.GroupName = data.data.GroupName || "";
                                //fileRet.StartDate = "2025-11-09 15:38:00";
                                //fileRet.EndDate = "2025-11-09 15:37:00";
                                if (fileRet.StartDate) {
                                    //replace T and Z to space
                                    fileRet.StartDate = fileRet.StartDate.replace("T", " ").replace(".000Z", "");
                                    //add timezone
                                    let fileRetStartDateObj = new Date(fileRet.StartDate + " UTC");
                                    let fileRetStartDateObjOffset = fileRetStartDateObj.getTimezoneOffset();
                                    fileRetStartDateObj = new Date(fileRetStartDateObj.getTime() - fileRetStartDateObjOffset * 60000);
                                    fileRet.StartDate = fileRetStartDateObj.toISOString().replace("T", " ").replace(".000Z", "");
                                }
                                if (fileRet.EndDate) {
                                    //replace T and Z to space
                                    fileRet.EndDate = fileRet.EndDate.replace("T", " ").replace(".000Z", "");
                                    //add timezone
                                    let fileRetEndDateObj = new Date(fileRet.EndDate + " UTC");
                                    let fileRetEndDateObjOffset = fileRetEndDateObj.getTimezoneOffset();
                                    fileRetEndDateObj = new Date(fileRetEndDateObj.getTime() - fileRetEndDateObjOffset * 60000);
                                    fileRet.EndDate = fileRetEndDateObj.toISOString().replace("T", " ").replace(".000Z", "");
                                    console.log("Adjusted EndDate: " + fileRet.EndDate);
                                }
                                fileRet.NameChinese = data.data.NameChinese || "";
                                fileRet.NameEnglish = data.data.NameEnglish || "";
                                fileRet.StatusError = "";
                                //
                                if (data.revokedStatus) {
                                    fileRet.StatusError = "revoked"; //StatusError expired revoked not_found.
                                    fileRet.Status = "fail";
                                } else {
                                    //check if expired
                                    //check start date
                                    if (fileRet.StartDate) {
                                        let startDate = new Date(fileRet.StartDate);
                                        let now = new Date();
                                        if (startDate > now) {
                                            fileRet.StatusError = "not_found"; //StatusError expired revoked not_found. or not_effective
                                            fileRet.Status = "fail";
                                        }
                                    } else {
                                        fileRet.StatusError = "not_found"; //StatusError expired revoked not_found. or not_effective
                                        fileRet.Status = "fail";
                                    }
                                    //check end date
                                    if (fileRet.EndDate) {
                                        let endDate = new Date(fileRet.EndDate);
                                        let now = new Date();
                                        if (endDate < now) {
                                            fileRet.StatusError = "expired"; //StatusError expired revoked not_found.
                                            fileRet.Status = "fail";
                                        }
                                    }
                                }
                            } else {
                                fileRet.Filename = aFile.name;
                                fileRet.Status = "fail";
                                fileRet.RegistrationNo = "";
                                fileRet.Name = "";
                                fileRet.AddressEnglish = "";
                                fileRet.StartDate = "";
                                fileRet.StatusError = "";
                            }
                            this.filesResultDict[aFile.name] = fileRet;
                            this.filesDone++;
                            //check in not cancel
                            if (this.status == "uploading") {
                                if (this.filesDone >= this.filesTotal) this.showResult();
                            }
                        }).catch((error)=>{
                            let fileRet = {};
                            fileRet.Filename = aFile.name;
                            fileRet.Status = "fail";
                            fileRet.RegistrationNo = "";
                            fileRet.Name = "";
                            fileRet.AddressEnglish = "";
                            fileRet.StartDate = "";
                            this.filesResultDict[aFile.name] = fileRet;
                            if (this.status == "uploading") {
                                if (this.filesDone >= this.filesTotal) this.showResult();
                            }
                            console.error(error);
                        });
                    // setTimeout(() => {
                    //     this.status = "success";
                    // }, 1000);
                    };
                }
            },
            showResult () {
                this.filesResult = [];
                for(const key in this.filenames){
                    let stringName = this.filenames[key];
                    let dict = this.filesResultDict[stringName];
                    if (dict) this.filesResult.push(dict);
                }
                this.status = "done";
                //check if single file, show single file result success or fail
                if (this.filesResult.length == 1) {
                    let fileRet = this.filesResult[0];
                    if (fileRet.Status == "success") this.status = "success";
                    else this.status = "fail";
                }
            },
            submit () {
                this.status = "uploading";
                if (this.file === null) return false;
                this.filename = this.file.name;
                const reader = new FileReader();
                reader.readAsArrayBuffer(this.file);
                reader.onload = async (event)=>{
                    const fileContent = event.target.result;
                    let hex = await $bc4f20284337a43e$var$calcSha256(fileContent);
                    //console.log(hex);
                    const options = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            hash: hex
                        })
                    };
                    //call api to validate the hash
                    fetch($bc4f20284337a43e$var$API_ENDPOINT + "/api/verify", options).then((response)=>response.json()).then((data)=>{
                        //console.log(data);
                        if (data.success) //check in not cancel
                        {
                            if (this.status == "uploading") {
                                this.status = "success";
                                this.resultRegistrationNo = data.data.RegistrationNo || "";
                                this.resultNameChinese = data.data.NameChinese || "";
                                this.resultAddressEnglish = data.data.AddressEnglish || "";
                                this.resultStartDate = data.data.StartDate || "";
                            }
                        } else if (this.status == "uploading") {
                            this.status = "fail";
                            this.resultRegistrationNo = "";
                            this.resultNameChinese = "";
                            this.resultAddressEnglish = "";
                            this.resultStartDate = "";
                        }
                    }).catch((error)=>console.error(error));
                // setTimeout(() => {
                //     this.status = "success";
                // }, 1000);
                };
            },
            reset () {
                this.status = "waiting-input";
                this.filename = "";
                this.resultRegistrationNo = "";
                this.resultNameChinese = "";
                this.resultAddressEnglish = "";
                this.resultStartDate = "";
                const fileInput = document.getElementById("filef");
                fileInput.value = null;
            },
            isErrorNotFound (dateString) {
                return dateString != "expired" && dateString != "revoked" // && dateString != "not_effective"
                ;
            },
            isErrorExpired (dateString) {
                return dateString == "expired";
            },
            isErrorRevoked (dateString) {
                return dateString == "revoked";
            },
            isErrorNotEffective (dateString) {
                return dateString == "not_effective";
            }
        }));
});
(0, $83ff99eb528b29b5$export$2e2bcd8739ae039).start();
async function $bc4f20284337a43e$var$calcSha256(txt) {
    const hash = new (0, $cc8500bd1d8c4094$exports.Sha256)();
    hash.update(txt);
    const result = await hash.digest();
    //let decoder = new TextDecoder('utf-8');
    //let string = decoder.decode(result);
    //const uint8array = new Uint8Array([10, 20, 30, 40, 50]);
    const hexString = Array.from(result).map((byte)=>("0" + byte.toString(16)).slice(-2)).join("");
    //console.log(result.toString());
    //console.log(hexString);
    return hexString;
} //console.log(calcSha256("txt"));


//# sourceMappingURL=app.047caef5.js.map
